/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** AddOpenItemReqDTO */
export interface AddOpenItemReqDTO {
  /** app key */
  appKey: string;
  /**
   * customer shop id
   * @format int64
   */
  customerShopId: number;
  /** item code */
  itemCode: string;
  /** item name */
  itemName: string;
  /** item main image */
  mainImage?: string;
  /** item sale price */
  salePrice?: number;
  /** sign */
  sign: string;
  /** sku list */
  skuList?: OpenItemSkuDTO[];
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** AdditionCheckTypePojo */
export interface AdditionCheckTypePojo {
  /** @format int32 */
  additionCheckType?: number;
  warehouseCode?: string;
  warehouseCountry?: string;
}

/** AdditionUpdatePojo */
export interface AdditionUpdatePojo {
  /** @format int64 */
  newAdditionConfigId?: number;
  /** @format int64 */
  oldAdditionConfigId?: number;
}

/** AdditionsPojo */
export interface AdditionsPojo {
  additionalList?: ThirdShopItemAddition[];
  warehouseCode?: string;
  warehouseCountry?: string;
}

/** Address */
export interface Address {
  /** The street address information. */
  addressLine1: string;
  /** Additional street address information, if required. */
  addressLine2?: string;
  /** The city. */
  city: string;
  /** The country code in two-character ISO 3166-1 alpha-2 format. */
  countryCode: string;
  /** The district or county. */
  districtOrCounty?: string;
  /** Name of the individual or business. */
  name: string;
  /** The postal code.  If postal codes are used in your marketplace, we recommended that you include one with your request. This helps Amazon select the most appropriate Amazon fulfillment center for the inbound shipment plan. */
  postalCode: string;
  /** The state or province code.  If state or province codes are used in your marketplace, it is recommended that you include one with your request. This helps Amazon to select the most appropriate Amazon fulfillment center for your inbound shipment plan. */
  stateOrProvinceCode: string;
}

/** AmazonError */
export interface AmazonError {
  code?: string;
  details?: string;
  message?: string;
}

/** AmazonProduct */
export interface AmazonProduct {
  amazonAsin?: string;
  amazonFnsku?: string;
  amazonMsku?: string;
  /** @format int32 */
  amazonNotSellQuantity?: number;
  /** @format int32 */
  amazonPredictTotalQuantity?: number;
  /** @format int32 */
  amazonReservedQuantity?: number;
  /** @format int32 */
  amazonSellQuantity?: number;
  /** @format int32 */
  amazonStockInQuantity?: number;
  /** @format int32 */
  amazonSurveyQuantity?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  id?: number;
  labelOwnerConstraint?: string;
  mainImg?: string;
  prepOwnerConstraint?: string;
  productName?: string;
  productProp?: string;
  productSku?: string;
  /** @format int32 */
  sellStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** AmazonProductResp */
export interface AmazonProductResp {
  amazonAsin?: string;
  amazonFnsku?: string;
  amazonMsku?: string;
  /** @format int32 */
  amazonNotSellQuantity?: number;
  /** @format int32 */
  amazonPredictTotalQuantity?: number;
  /** @format int64 */
  amazonProductId?: number;
  /** @format int32 */
  amazonReservedQuantity?: number;
  /** @format int32 */
  amazonSellQuantity?: number;
  /** @format int32 */
  amazonStockInQuantity?: number;
  /** @format int32 */
  amazonSurveyQuantity?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  mainImg?: string;
  productName?: string;
  productProp?: string;
  productSku?: string;
  /** @format int32 */
  sellStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** AmazonResponseBody */
export interface AmazonResponseBody {
  errors?: AmazonError[];
}

/**
 * Amount
 * The monetary value.
 */
export interface Amount {
  currencyCode: "USD" | "GBP";
  /** The amount. */
  value: number;
}

/** ApiShopInfoResp */
export interface ApiShopInfoResp {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  noBindShopProductSkuCount?: number;
  /** @format int32 */
  notFinishedOrderCount?: number;
  /** @format int32 */
  orderStatusFailCount?: number;
}

/** BatchUpdateSyncLogisticsNoReq */
export interface BatchUpdateSyncLogisticsNoReq {
  shopOrderIds?: number[];
  /** @format int32 */
  status?: number;
}

/** BindedShopSkuInfo */
export interface BindedShopSkuInfo {
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSkuCode?: string;
}

/** BizResponse */
export interface BizResponse {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/**
 * BoxContentsFeeDetails
 * The manual processing fee per unit and total fee for a shipment.
 */
export interface BoxContentsFeeDetails {
  /** The manual processing fee per unit. */
  feePerUnit?: Amount;
  /** The total manual processing fee for the shipment. */
  totalFee?: Amount;
  /**
   * The number of units to ship.
   * @format int32
   */
  totalUnits?: number;
}

/**
 * BoxInput
 * Input information for a given box.
 */
export interface BoxInput {
  /** The dimension values and unit of measurement. */
  dimensions?: Dimensions;
  items?: ItemInput[];
  /** @format int32 */
  quantity?: number;
  /** The weight of the package. */
  weight?: Weight;
}

/** Cafe24AuthRequest */
export interface Cafe24AuthRequest {
  code?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  thirdShopId?: string;
}

/** CartonItemVO */
export interface CartonItemVO {
  quantityInCase?: string;
  quantityShipped?: string;
  sku?: string;
}

/** CartonVO */
export interface CartonVO {
  cartonItemList?: CartonItemVO[];
}

/** CombinationPlatformProduct */
export interface CombinationPlatformProduct {
  combinationProduct?: CombinationProduct;
  commonPlatformProducts?: CommonPlatformProductDTO[];
  oemPlatformProducts?: OemPlatformProductDTO[];
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
}

/** CombinationProduct */
export interface CombinationProduct {
  combinationProductMainImg?: string;
  combinationProductName?: string;
  combinationProductProp?: string;
  combinationProductSku?: string;
  country?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  /** @format int32 */
  existWaitCombinationFlag?: number;
  productSellPrice?: number;
  /** @format int32 */
  systemSource?: number;
  unitPrice?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CombinationSubProduct */
export interface CombinationSubProduct {
  /** @format int32 */
  additionCheckType?: number;
  additionList?: ThirdShopItemAddition[];
  /** @format int64 */
  combinationProductItemId?: number;
  combinationProductSku?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  goodsCountry?: string;
  /** @format int32 */
  minOrderQuantity?: number;
  /** @format int64 */
  productCategoryFrontendNdId?: number;
  productCode?: string;
  productPropertiesName?: string;
  productSellPrice?: number;
  productSku?: string;
  productSkuImg?: string;
  productTitle?: string;
  productTitleJp?: string;
  /** @format int32 */
  productType?: number;
  shopProductSku?: string;
  /** @format int32 */
  unitNums?: number;
}

/** CommonPlatformProduct */
export interface CommonPlatformProduct {
  bought?: boolean;
  /** @format int32 */
  channel?: number;
  country?: string;
  /** @format int64 */
  customerId?: number;
  gradientPrices?: GradientPrice[];
  isInBlank?: boolean;
  isInProductCategoryClose?: boolean;
  isOnline?: boolean;
  isOnlineProduct?: boolean;
  materialInfoJa?: string;
  materialInfoZh?: string;
  productCategoryFrontendNdId?: string;
  productCode?: string;
  productCustoms?: ProductCustoms;
  /** @format int64 */
  productCustomsId?: number;
  productDetailUrl?: string;
  productImage?: string;
  productItemCategoryZh?: string;
  productOriginSellPrice?: number;
  productProperties?: string;
  productPropertiesName?: string;
  productPropertiesNameParse?: string;
  productSellPrice?: number;
  /** @format int32 */
  productSellQuantity?: number;
  productSku?: string;
  productSkuImg?: string;
  /** @format int32 */
  productStockQuantity?: number;
  productTitle?: string;
  productTitleJp?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  recommendProductSku?: string;
  skuId?: string;
  skuPrice?: number;
  specId?: string;
  stallProductSellPrice?: number;
}

/** CommonPlatformProductDTO */
export interface CommonPlatformProductDTO {
  commonPlatformProduct?: CommonPlatformProduct;
  /** @format int32 */
  num?: number;
}

/** CommonTransportResult */
export interface CommonTransportResult {
  /** The workflow status for a shipment with an Amazon-partnered carrier. */
  transportResult?: TransportResult;
}

/**
 * Contact
 * Contact information for the person in the seller's organization who is responsible for a Less Than Truckload/Full Truckload (LTL/FTL) shipment.
 */
export interface Contact {
  /** The email address of the contact person. */
  email: string;
  /** The fax number of the contact person. */
  fax?: string;
  /** The name of the contact person. */
  name: string;
  /** The phone number of the contact person. */
  phone: string;
}

/** CreateInboundShipmentPlanReq */
export interface CreateInboundShipmentPlanReq {
  /** The request schema for the createInboundShipmentPlan operation. */
  createInboundShipmentPlanRequest?: CreateInboundShipmentPlanRequest;
  /** @format int64 */
  customerShopId?: number;
}

/**
 * CreateInboundShipmentPlanRequest
 * The request schema for the createInboundShipmentPlan operation.
 */
export interface CreateInboundShipmentPlanRequest {
  inboundShipmentPlanRequestItems: InboundShipmentPlanRequestItem[];
  /** The seller's preference for label preparation for an inbound shipment. */
  labelPrepPreference: "SELLER_LABEL" | "AMAZON_LABEL_ONLY" | "AMAZON_LABEL_PREFERRED";
  /** The address from which the inbound shipment will be sent. */
  shipFromAddress: Address;
  /** The two-character country code for the country where the inbound shipment is to be sent.  Note: Not required. Specifying both ShipToCountryCode and ShipToCountrySubdivisionCode returns an error.   Values:   ShipToCountryCode values for North America:  * CA – Canada  * MX - Mexico  * US - United States  ShipToCountryCode values for MCI sellers in Europe:  * DE – Germany  * ES – Spain  * FR – France  * GB – United Kingdom  * IT – Italy  Default: The country code for the seller's home marketplace. */
  shipToCountryCode?: string;
  /** The two-character country code, followed by a dash and then up to three characters that represent the subdivision of the country where the inbound shipment is to be sent. For example, "IN-MH". In full ISO 3166-2 format.  Note: Not required. Specifying both ShipToCountryCode and ShipToCountrySubdivisionCode returns an error. */
  shipToCountrySubdivisionCode?: string;
}

/** CreateInboundShipmentPlanResp */
export interface CreateInboundShipmentPlanResp {
  amazonResponseBody?: AmazonResponseBody;
  /** 错误列表 */
  errorList?: ErrorSku[];
  inboundShipmentPlans?: InboundShipmentPlan[];
  success?: boolean;
  taskId?: string;
}

/** CreateInboundShipmentReq */
export interface CreateInboundShipmentReq {
  /** @format int64 */
  customerShopId?: number;
  /** The request schema for an inbound shipment. */
  inboundShipmentRequest?: InboundShipmentRequest;
  shipmentId?: string;
}

/** CreateInboundShipmentResp */
export interface CreateInboundShipmentResp {
  amazonResponseBody?: AmazonResponseBody;
  /** A list of error responses returned when a request is unsuccessful. */
  errorList?: ErrorList;
  shipmentId?: string;
  success?: boolean;
}

/** CreateOrderReqDTO */
export interface CreateOrderReqDTO {
  /** app key */
  appKey: string;
  /**
   * currency (JPY,CNY,USD.......)
   * @example "JPY"
   */
  currency: string;
  /**
   * customer shop id
   * @format int64
   */
  customerShopId: number;
  /** order items */
  items?: OrderItem[];
  /** order total amount */
  orderAmount: number;
  /** order number, if null, it will be automatically generated */
  orderNo?: string;
  /**
   * ordered time default current time
   * @format date-time
   */
  orderTime?: string;
  /** receiver info */
  receiver?: Receiver;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** CreateReplenishPlanAddressReq */
export interface CreateReplenishPlanAddressReq {
  address?: string;
  area?: string;
  city?: string;
  clubCode?: string;
  companyName?: string;
  email?: string;
  mobile?: string;
  name?: string;
  nation?: string;
  postalCode?: string;
  province?: string;
}

/** CreateReplenishPlanItemReq */
export interface CreateReplenishPlanItemReq {
  /** @format int32 */
  deliveryNums?: number;
  shopProductSku?: string;
}

/** CreateReplenishPlanReq */
export interface CreateReplenishPlanReq {
  additionalList?: SubmitAdditionReq[];
  branchCode?: string;
  declarationAddress?: CreateReplenishPlanAddressReq;
  declarationDiscount?: number;
  distribution?: string;
  financialInstitutionCode?: string;
  forwarder?: string;
  importerCode?: string;
  /** @format int64 */
  intForwarderConfigId?: number;
  /** @format int64 */
  intShipConfigId?: number;
  /** @format int64 */
  labelTemplateId?: number;
  originalDeclarationAddress?: CreateReplenishPlanAddressReq;
  /** @format int32 */
  priceDeclarationType?: number;
  replenishPlanItemList?: CreateReplenishPlanItemReq[];
  shippingType?: string;
  /** @format int32 */
  tariffType?: number;
  taxDeductionAccount?: string;
  title?: string;
  warehouseCode?: string;
}

/** CreateShopOrderRequest */
export interface CreateShopOrderRequest {
  /** @format int64 */
  customerShopId?: number;
  shopOrderIds?: number[];
  useOneTheWayInventory?: boolean;
}

/** CreateXmlVO */
export interface CreateXmlVO {
  boxInputList?: BoxInput[];
  cartonList?: CartonVO[];
  messageId?: string;
  /** @format int32 */
  numCartons?: number;
  sellerId?: string;
  shipmentId?: string;
  xmlPath?: string;
}

/** CustomerReplenishPlanReq */
export interface CustomerReplenishPlanReq {
  amazonMsku?: string;
  amazonMskuList?: string[];
  /** @format int64 */
  customerShopId?: number;
  deliveryTaskCode?: string;
  deliveryTaskCodeList?: string[];
  keywordName?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  planStatus?: number;
  productSku?: string;
  productSkuList?: string[];
  shipmentId?: string;
  shipmentIdList?: string[];
}

/** CustomerShopAuthResp */
export interface CustomerShopAuthResp {
  accessToken?: string;
  /** @format int64 */
  customerShopAuthId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  customerShopPlatform?: number;
  refreshToken?: string;
  /** @format date-time */
  refreshTokenExpireDate?: string;
  shopId?: string;
  shopName?: string;
  shopUrl?: string;
}

/** DelAppWebhookDTO */
export interface DelAppWebhookDTO {
  /** @format int32 */
  event_no?: number;
  resource?: ResourceDTO;
}

/** DeleteShopOrderItemRequest */
export interface DeleteShopOrderItemRequest {
  shopOrderItemIds?: number[];
}

/** DeleteShopOrderRequest */
export interface DeleteShopOrderRequest {
  shopOrderIds?: number[];
}

/** DeliveryAdditionsPojo */
export interface DeliveryAdditionsPojo {
  deliveryAdditionalList?: ThirdShopOrderDeliveryAddition[];
  warehouseCode?: string;
  warehouseCountry?: string;
  warehouseName?: string;
}

/**
 * Dimensions
 * The dimension values and unit of measurement.
 */
export interface Dimensions {
  /** The height dimension. */
  height: number;
  /** The length dimension. */
  length: number;
  /** The unit of measurement for the dimensions. */
  unit: "inches" | "centimeters";
  unitOfMeasurement: "IN" | "CM";
  /** The width dimension. */
  width: number;
}

/** EditDeliveryAdditionsRequest */
export interface EditDeliveryAdditionsRequest {
  deliveryAdditions?: ThirdShopOrderDeliveryAddition[];
  shopOrderIds?: string[];
  warehouseCode?: string;
}

/** EditIntShipConfigRequest */
export interface EditIntShipConfigRequest {
  intShipConfigList?: IntShipConfigPojo[];
  shopOrderIds?: number[];
}

/**
 * Error
 * An error response returned when the request is unsuccessful.
 */
export interface Error {
  /** An error code that identifies the type of error that occurred. */
  code: string;
  /** Additional details that can help the caller understand or fix the issue. */
  details?: string;
  /** A message that describes the error condition in a human-readable form. */
  message: string;
}

/**
 * ErrorList
 * A list of error responses returned when a request is unsuccessful.
 */
export interface ErrorList {
  errors: Error[];
}

/** ErrorSku */
export interface ErrorSku {
  /** 失败 sku 列表 */
  amazonSku?: string[];
  /** 失败原因 */
  reason?: string;
}

/** GetAmazonProductByMskuRequest */
export interface GetAmazonProductByMskuRequest {
  amazonMsku?: string;
  /** @format int64 */
  customerShopId?: number;
}

/** GetLabelReq */
export interface GetLabelReq {
  /** @format int64 */
  customerShopId?: number;
  labelType?: string;
  /** @format int32 */
  numberOfPackages?: number;
  /** @format int32 */
  numberOfPallets?: number;
  packageLabelsToPrint?: string[];
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  pageStartIndex?: number;
  pageType?: string;
  shipmentId?: string;
}

/** GetLabelResp */
export interface GetLabelResp {
  downloadUrl?: string;
}

/** GetOrderReqDTO */
export interface GetOrderReqDTO {
  /** app key */
  appKey: string;
  /**
   * customer shop id
   * @format int64
   */
  customerShopId: number;
  /** order number separated by commas */
  orderNos: string;
  /** sign */
  sign: string;
  /**
   * timestamp
   * @format int64
   */
  timestamp: number;
}

/** GetUploadStatusReq */
export interface GetUploadStatusReq {
  /** @format int64 */
  customerShopId?: number;
  feedId?: string;
}

/** GetUploadStatusResp */
export interface GetUploadStatusResp {
  feedId?: string;
  feedType?: string;
  processingStatus?: "CANCELLED" | "DONE" | "FATAL" | "IN_PROGRESS" | "IN_QUEUE";
  resultFeedDocumentId?: string;
}

/** GradientPrice */
export interface GradientPrice {
  /** @format int32 */
  minQuantity?: number;
  price?: number;
}

/**
 * InboundShipmentHeader
 * Inbound shipment information used to create and update inbound shipments.
 */
export interface InboundShipmentHeader {
  /** Indicates whether or not an inbound shipment contains case-packed boxes. Note: A shipment must contain either all case-packed boxes or all individually packed boxes.  Possible values:  true - All boxes in the shipment must be case packed.  false - All boxes in the shipment must be individually packed.  Note: If AreCasesRequired = true for an inbound shipment, then the value of QuantityInCase must be greater than zero for every item in the shipment. Otherwise the service returns an error. */
  areCasesRequired?: boolean;
  /** The identifier for the fulfillment center to which the shipment will be shipped. Get this value from the InboundShipmentPlan object in the response returned by the createInboundShipmentPlan operation. */
  destinationFulfillmentCenterId: string;
  intendedBoxContentsSource?: "NONE" | "FEED" | "2D_BARCODE";
  /** The preference for label preparation for an inbound shipment. */
  labelPrepPreference: "SELLER_LABEL" | "AMAZON_LABEL_ONLY" | "AMAZON_LABEL_PREFERRED";
  /** The return address. */
  shipFromAddress: Address;
  /** The name for the shipment. Use a naming convention that helps distinguish between shipments over time, such as the date the shipment was created. */
  shipmentName: string;
  shipmentStatus:
    | "WORKING"
    | "SHIPPED"
    | "RECEIVING"
    | "CANCELLED"
    | "DELETED"
    | "CLOSED"
    | "ERROR"
    | "IN_TRANSIT"
    | "DELIVERED"
    | "CHECKED_IN";
}

/**
 * InboundShipmentItem
 * Item information for an inbound shipment. Submitted with a call to the createInboundShipment or updateInboundShipment operation.
 */
export interface InboundShipmentItem {
  /** Amazon's fulfillment network SKU of the item. */
  fulfillmentNetworkSKU?: string;
  prepDetailsList?: PrepDetails[];
  /**
   * The item quantity in each case, for case-packed items. Note that QuantityInCase multiplied by the number of boxes in the inbound shipment equals QuantityShipped. Also note that all of the boxes of an inbound shipment must either be case packed or individually packed. For that reason, when you submit the createInboundShipment or the updateInboundShipment operation, the value of QuantityInCase must be provided for every item in the shipment or for none of the items in the shipment.
   * @format int32
   */
  quantityInCase?: number;
  /**
   * The item quantity that has been received at an Amazon fulfillment center.
   * @format int32
   */
  quantityReceived?: number;
  /**
   * The item quantity that you are shipping.
   * @format int32
   */
  quantityShipped: number;
  /** The date that a pre-order item will be available for sale. */
  releaseDate?: string;
  /** The seller SKU of the item. */
  sellerSKU: string;
  /** A shipment identifier originally returned by the createInboundShipmentPlan operation. */
  shipmentId?: string;
}

/**
 * InboundShipmentPlan
 * Inbound shipment information used to create an inbound shipment. Returned by the createInboundShipmentPlan operation.
 */
export interface InboundShipmentPlan {
  /** An Amazon fulfillment center identifier created by Amazon. */
  destinationFulfillmentCenterId: string;
  /** The manual processing fee per unit and total fee for a shipment. */
  estimatedBoxContentsFee?: BoxContentsFeeDetails;
  /** SKU and quantity information for the items in the shipment. */
  items: InboundShipmentPlanItem[];
  labelPrepType: "NO_LABEL" | "SELLER_LABEL" | "AMAZON_LABEL";
  /** The address of the Amazon fulfillment center to which to ship the items. */
  shipToAddress: Address;
  /** A shipment identifier originally returned by the createInboundShipmentPlan operation. */
  shipmentId: string;
}

/**
 * InboundShipmentPlanItem
 * Item information used to create an inbound shipment. Returned by the createInboundShipmentPlan operation.
 */
export interface InboundShipmentPlanItem {
  /** Amazon's fulfillment network SKU of the item. */
  fulfillmentNetworkSKU: string;
  prepDetailsList?: PrepDetails[];
  /**
   * The item quantity that you are shipping.
   * @format int32
   */
  quantity: number;
  /** The seller SKU of the item. */
  sellerSKU: string;
}

/**
 * InboundShipmentPlanRequestItem
 * Item information for creating an inbound shipment plan. Submitted with a call to the createInboundShipmentPlan operation.
 */
export interface InboundShipmentPlanRequestItem {
  /** The Amazon Standard Identification Number (ASIN) of the item. */
  asin: string;
  condition:
    | "NewItem"
    | "NewWithWarranty"
    | "NewOEM"
    | "NewOpenBox"
    | "UsedLikeNew"
    | "UsedVeryGood"
    | "UsedGood"
    | "UsedAcceptable"
    | "UsedPoor"
    | "UsedRefurbished"
    | "CollectibleLikeNew"
    | "CollectibleVeryGood"
    | "CollectibleGood"
    | "CollectibleAcceptable"
    | "CollectiblePoor"
    | "RefurbishedWithWarranty"
    | "Refurbished"
    | "Club";
  prepDetailsList?: PrepDetails[];
  /** @format int32 */
  quantity: number;
  /**
   * The item quantity in each case, for case-packed items. Note that QuantityInCase multiplied by the number of cases in the inbound shipment equals Quantity. Also note that all of the boxes of an inbound shipment must either be case packed or individually packed. For that reason, when you submit the createInboundShipmentPlan operation, the value of QuantityInCase must be provided for every item in the shipment or for none of the items in the shipment.
   * @format int32
   */
  quantityInCase?: number;
  /** The seller SKU of the item. */
  sellerSKU: string;
}

/**
 * InboundShipmentRequest
 * The request schema for an inbound shipment.
 */
export interface InboundShipmentRequest {
  /** Inbound shipment information used to create and update inbound shipments. */
  inboundShipmentHeader: InboundShipmentHeader;
  inboundShipmentItems: InboundShipmentItem[];
  /** A marketplace identifier. Specifies the marketplace where the product would be stored. */
  marketplaceId: string;
}

/** IntShipConfigPojo */
export interface IntShipConfigPojo {
  distribution?: string;
  /** @format int64 */
  intShipConfigId?: number;
  logisticsLogo?: string;
  warehouseCode?: string;
  warehouseCountry?: string;
}

/** ItemAdditionDTO */
export interface ItemAdditionDTO {
  /** @format int32 */
  additionConfigId?: number;
  additionExtraName?: string;
  /** @format int32 */
  additionId?: number;
  additionName?: string;
  additionNameJp?: string;
  ingredientsSku?: string;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  warehouseCode?: string;
}

/**
 * ItemInput
 * Defines an item's input parameters.
 */
export interface ItemInput {
  /** The manufacturing lot code. */
  manufacturingLotCode?: string;
  /** Merchant SKU. */
  msku: string;
  /**
   * The number of units of the specified msku that will be shipped.
   * @format int32
   */
  quantity: number;
}

/** ItemSkuMappingQueryReq */
export interface ItemSkuMappingQueryReq {
  /** @format int64 */
  customerShopId?: number;
  productSkuList?: string[];
}

/** ItemSkuMappingResp */
export interface ItemSkuMappingResp {
  /** @format int64 */
  customerShopId?: number;
  mappingList?: SkuMappingInfo[];
  productSku?: string;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSkuAttribute?: string;
  thirdSkuCode?: string;
}

/** LastUpdateTimeResult */
export interface LastUpdateTimeResult {
  /** @format date-time */
  date?: string;
}

/** ListOnTheWayStockPageRequest */
export interface ListOnTheWayStockPageRequest {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  shopOrderIds?: number[];
  /** @format int32 */
  startIndex?: number;
}

/** ManualCreateOrderResult */
export interface ManualCreateOrderResult {
  errCode?: string;
  errMsg?: string;
  platformOrderNoList?: string[];
  /** @format int64 */
  shopOrderId?: number;
}

/** ManualSyncOrderRequest */
export interface ManualSyncOrderRequest {
  /** @format date-time */
  endTime?: string;
  /** @format date-time */
  startTime?: string;
}

/** MappingInfo */
export interface MappingInfo {
  operateFlag?: boolean;
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
}

/**
 * NonPartneredLtlDataInput
 * Information that you provide to Amazon about a Less Than Truckload/Full Truckload (LTL/FTL) shipment by a carrier that has not partnered with Amazon.
 */
export interface NonPartneredLtlDataInput {
  /** The carrier that you are using for the inbound shipment. */
  carrierName: string;
  proNumber: string;
}

/**
 * NonPartneredSmallParcelDataInput
 * Information that you provide to Amazon about a Small Parcel shipment shipped by a carrier that has not partnered with Amazon.
 */
export interface NonPartneredSmallParcelDataInput {
  /** The carrier that you are using for the inbound shipment. */
  carrierName: string;
  packageList: NonPartneredSmallParcelPackageInput[];
}

/**
 * NonPartneredSmallParcelPackageInput
 * The tracking number of the package, provided by the carrier.
 */
export interface NonPartneredSmallParcelPackageInput {
  trackingId: string;
}

/** OemPlatformProduct */
export interface OemPlatformProduct {
  color?: string;
  colorUrl?: string;
  colorZh?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  gradientPrices?: GradientPrice[];
  materials?: string;
  materialsUrl?: string;
  materialsZh?: string;
  /** @format int64 */
  oemProductClassificationId?: number;
  productCode?: string;
  productImage?: string;
  productSku?: string;
  productSkuProperties?: string;
  productTitle?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int32 */
  quantity?: number;
  remark?: string;
  searchSourceOrder?: SearchSourceOrder;
  /** @format int64 */
  searchSourceOrderSkuId?: number;
  size?: string;
  sizeUrl?: string;
  sizeZh?: string;
  style?: string;
  styleUrl?: string;
  styleZh?: string;
}

/** OemPlatformProductDTO */
export interface OemPlatformProductDTO {
  /** @format int32 */
  num?: number;
  oemPlatformProduct?: OemPlatformProduct;
}

/** OnTheWayStockQueryResoDTO */
export interface OnTheWayStockQueryResoDTO {
  /** @format int64 */
  onTheWayAvailableNum?: number;
  /** @format int64 */
  onTheWayOccupyNum?: number;
  /** @format int64 */
  onTheWayTotalNum?: number;
  productDetailUrl?: string;
  productMainImg?: string;
  productPropertiesName?: string;
  productSku?: string;
  productTitle?: string;
  /** @format int64 */
  skuOrderNum?: number;
}

/** OpenItemSkuDTO */
export interface OpenItemSkuDTO {
  /** sku attribute */
  skuAttribute?: string;
  /** sku code */
  skuCode: string;
  /** sku image */
  skuImage?: string;
  /** sku price */
  skuPrice: number;
}

/** OpenOrderRespDTO */
export interface OpenOrderRespDTO {
  /**
   * currency (JPY,CNY,USD.......)
   * @example "JPY"
   */
  currency?: string;
  /** order items */
  items?: OrderItem[];
  /** order total amount */
  orderAmount?: number;
  /** order number */
  orderNo?: string;
  /**
   * api order status, 0-not ordered 1-ordered success 2-pending 3-ordered failed
   * @format int32
   */
  orderSyncStatus?: number;
  /**
   * ordered time default current time
   * @format date-time
   */
  orderTime?: string;
  /** ckb platform order number */
  platformOrderNo?: string;
  /**
   * ckb platform order settle status 1-unsettlement 2-settling 3-settlement success 4-settlement failed
   * @format int32
   */
  platformOrderSettleStatus?: number;
  /** receiver info */
  receiver?: Receiver;
}

/** OrderDeliveryReq */
export interface OrderDeliveryReq {
  deliveryProductSkus?: string[];
  deliveryShopProductSkus?: string[];
  isLastLogistics?: boolean;
  logisticsCompanyCode?: string;
  /** @format int64 */
  shopOrderId?: number;
  trackingNumber?: string;
  trackingProvider?: string;
  trackingProviderKey?: string;
  trackingUrl?: string;
}

/** OrderItem */
export interface OrderItem {
  /** item amount */
  itemAmount: number;
  /**
   * order quantity
   * @format int32
   */
  quantity: number;
  /** sku code */
  skuCode: string;
}

/**
 * Pallet
 * Pallet information.
 */
export interface Pallet {
  /** The dimensions of the pallet. Length and width must be 40 inches by 48 inches. Height must be less than or equal to 60 inches. */
  dimensions: Dimensions;
  /** Indicates whether pallets will be stacked when carrier arrives for pick-up. */
  isStacked: boolean;
  /** The weight of the pallet. */
  weight?: Weight;
}

/**
 * PartneredLtlDataInput
 * Information that is required by an Amazon-partnered carrier to ship a Less Than Truckload/Full Truckload (LTL/FTL) inbound shipment.
 */
export interface PartneredLtlDataInput {
  /**
   * The number of boxes in the shipment.
   * @format int32
   */
  boxCount?: number;
  /** Contact information for the person in the seller's organization who is responsible for the shipment. Used by the carrier if they have questions about the shipment. */
  contact?: Contact;
  /** The date that the shipment will be ready to be picked up by the carrier. */
  freightReadyDate?: string;
  palletList?: Pallet[];
  /** The declaration of the total value of the inventory in the shipment. */
  sellerDeclaredValue?: Amount;
  sellerFreightClass?:
    | "50"
    | "55"
    | "60"
    | "65"
    | "70"
    | "77.5"
    | "85"
    | "92.5"
    | "100"
    | "110"
    | "125"
    | "150"
    | "175"
    | "200"
    | "250"
    | "300"
    | "400"
    | "500";
  /** The total weight of the shipment. */
  totalWeight?: Weight;
}

/**
 * PartneredSmallParcelDataInput
 * Information that is required by an Amazon-partnered carrier to ship a Small Parcel inbound shipment.
 */
export interface PartneredSmallParcelDataInput {
  /** The Amazon-partnered carrier to use for the inbound shipment. */
  carrierName?: string;
  packageList?: PartneredSmallParcelPackageInput[];
}

/**
 * PartneredSmallParcelPackageInput
 * Dimension and weight information for the package.
 */
export interface PartneredSmallParcelPackageInput {
  /** The dimension values and unit of measurement. */
  dimensions: Dimensions;
  /** The weight of the package. */
  weight: Weight;
}

/** PlatformItemSkuResp */
export interface PlatformItemSkuResp {
  /** @format int64 */
  oemProductClassificationId?: number;
  productCode?: string;
  productCountry?: string;
  productPropertiesName?: string;
  productSku?: string;
  productSkuImg?: string;
  productTitle?: string;
  /** @format int32 */
  productType?: number;
  /** @format int64 */
  searchSourceOrderId?: number;
  searchSourceOrderNo?: string;
}

/** PlatformLogisticsResp */
export interface PlatformLogisticsResp {
  bizId?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  customerShopPlatform?: number;
  name?: string;
  /** @format int64 */
  platformLogisticsId?: number;
  /** @format date-time */
  updateTime?: string;
}

/** PlatformOrderVO */
export interface PlatformOrderVO {
  /** @format int64 */
  platformOrderId?: number;
  platformOrderNo?: string;
}

/**
 * PrepDetails
 * Preparation instructions and who is responsible for the preparation.
 */
export interface PrepDetails {
  prepInstruction: "Polybagging" | "BubbleWrapping" | "Taping" | "BlackShrinkWrapping" | "Labeling" | "HangGarment";
  prepOwner: "AMAZON" | "SELLER";
}

/** ProductCustoms */
export interface ProductCustoms {
  compilationMethod?: string;
  compilationMethodEn?: string;
  customsCode?: string;
  customsPriceJp?: number;
  /** @format int64 */
  productCustomsId?: number;
  productItemCategoryEn?: string;
  productItemCategoryZh?: string;
  simpleReportCode?: string;
}

/** PublishItemToShopRequest */
export interface PublishItemToShopRequest {
  languageCode?: string;
  productCode?: string;
  /** @format int32 */
  purchaseChannel?: number;
}

/** PutTransportDetailsReq */
export interface PutTransportDetailsReq {
  /** @format int64 */
  customerShopId?: number;
  planNo?: string;
  /** The request schema for a putTransportDetails operation. */
  request?: PutTransportDetailsRequest;
  shipmentId?: string;
}

/**
 * PutTransportDetailsRequest
 * The request schema for a putTransportDetails operation.
 */
export interface PutTransportDetailsRequest {
  /** Indicates whether a putTransportDetails request is for an Amazon-partnered carrier. */
  isPartnered: boolean;
  shipmentType: "SP" | "LTL";
  /** Information required to create an Amazon-partnered carrier shipping estimate, or to alert the Amazon fulfillment center to the arrival of an inbound shipment by a non-Amazon-partnered carrier. */
  transportDetails: TransportDetailInput;
}

/** PutTransportDetailsResp */
export interface PutTransportDetailsResp {
  commonTransportResult?: CommonTransportResult;
  /** A list of error responses returned when a request is unsuccessful. */
  errorList?: ErrorList;
}

/** QueryAmazonProductReq */
export interface QueryAmazonProductReq {
  amazonMskus?: string[];
  /** @format int64 */
  customerShopId?: number;
}

/** QueryAmazonProductRequest */
export interface QueryAmazonProductRequest {
  amazonMskuList?: string[];
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  productName?: string;
}

/** QueryOrderCountRespDTO */
export interface QueryOrderCountRespDTO {
  /** @format int32 */
  createOrderNum?: number;
  /** @format int32 */
  noCreateOrderNum?: number;
}

/** QueryShopOrderRequest */
export interface QueryShopOrderRequest {
  orderName?: string;
  orderNames?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  queryType?: number;
  receiveName?: string;
  /** @format date-time */
  shopOrderEndTime?: string;
  shopOrderNo?: string;
  shopOrderNos?: string[];
  /** @format date-time */
  shopOrderStartTime?: string;
}

/** Receiver */
export interface Receiver {
  /** receiver detail address */
  address: string;
  /** city */
  city: string;
  /** country code，Japan: JP */
  countryCode: string;
  /** receiver email */
  email?: string;
  /** receiver name */
  name: string;
  /** receiver phone */
  phone: string;
  /** postal code */
  postalCode: string;
  /** prefectures */
  province: string;
}

/** RemoveAmazonProductRequest */
export interface RemoveAmazonProductRequest {
  amazonMsku?: string;
}

/** ReplenishPlanAddressResp */
export interface ReplenishPlanAddressResp {
  address?: string;
  /** @format int32 */
  addressType?: number;
  area?: string;
  city?: string;
  clubCode?: string;
  companyName?: string;
  email?: string;
  mobile?: string;
  name?: string;
  nation?: string;
  postalCode?: string;
  province?: string;
  /** @format int64 */
  replenishPlanAddressId?: number;
  /** @format int64 */
  replenishPlanId?: number;
  replenishPlanNo?: string;
}

/** ReplenishPlanItemResp */
export interface ReplenishPlanItemResp {
  amazonAsin?: string;
  amazonFnsku?: string;
  amazonMsku?: string;
  amazonProductTitle?: string;
  /** @format int32 */
  deliveryNums?: number;
  overseaProductSku?: string;
  productImg?: string;
  productSku?: string;
  productTitle?: string;
  /** @format int64 */
  replenishPlanId?: number;
  /** @format int64 */
  replenishPlanItemId?: number;
  replenishPlanNo?: string;
  shopProductSku?: string;
}

/** ReplenishPlanListReq */
export interface ReplenishPlanListReq {
  customerShopIds?: number[];
  /** @format int32 */
  planStatus?: number;
  replenishPlanIds?: number[];
}

/** ReplenishPlanResp */
export interface ReplenishPlanResp {
  addressList?: ReplenishPlanAddressResp[];
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  customerName?: string;
  /** @format int64 */
  customerShopId?: number;
  customerShopName?: string;
  deliveryTaskCode?: string;
  forwarder?: string;
  intForwarderConfigId?: string;
  /** @format int64 */
  intShipConfigId?: number;
  /** @format int32 */
  planStatus?: number;
  receiverWarehouse?: string;
  /** @format int64 */
  replenishPlanId?: number;
  replenishPlanItemList?: ReplenishPlanItemResp[];
  replenishPlanNo?: string;
  shipmentId?: string;
  shippingType?: string;
  shippingTypeJp?: string;
  title?: string;
  unificationCustomerFullName?: string;
}

/** ResourceDTO */
export interface ResourceDTO {
  app_name?: string;
  client_id?: string;
  deleted_date?: string;
  mall_id?: string;
}

/** ResponseEntity */
export interface ResponseEntity {
  body?: object;
  statusCode?:
    | "100 CONTINUE"
    | "101 SWITCHING_PROTOCOLS"
    | "102 PROCESSING"
    | "103 CHECKPOINT"
    | "200 OK"
    | "201 CREATED"
    | "202 ACCEPTED"
    | "203 NON_AUTHORITATIVE_INFORMATION"
    | "204 NO_CONTENT"
    | "205 RESET_CONTENT"
    | "206 PARTIAL_CONTENT"
    | "207 MULTI_STATUS"
    | "208 ALREADY_REPORTED"
    | "226 IM_USED"
    | "300 MULTIPLE_CHOICES"
    | "301 MOVED_PERMANENTLY"
    | "302 FOUND"
    | "302 MOVED_TEMPORARILY"
    | "303 SEE_OTHER"
    | "304 NOT_MODIFIED"
    | "305 USE_PROXY"
    | "307 TEMPORARY_REDIRECT"
    | "308 PERMANENT_REDIRECT"
    | "400 BAD_REQUEST"
    | "401 UNAUTHORIZED"
    | "402 PAYMENT_REQUIRED"
    | "403 FORBIDDEN"
    | "404 NOT_FOUND"
    | "405 METHOD_NOT_ALLOWED"
    | "406 NOT_ACCEPTABLE"
    | "407 PROXY_AUTHENTICATION_REQUIRED"
    | "408 REQUEST_TIMEOUT"
    | "409 CONFLICT"
    | "410 GONE"
    | "411 LENGTH_REQUIRED"
    | "412 PRECONDITION_FAILED"
    | "413 PAYLOAD_TOO_LARGE"
    | "413 REQUEST_ENTITY_TOO_LARGE"
    | "414 URI_TOO_LONG"
    | "414 REQUEST_URI_TOO_LONG"
    | "415 UNSUPPORTED_MEDIA_TYPE"
    | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
    | "417 EXPECTATION_FAILED"
    | "418 I_AM_A_TEAPOT"
    | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
    | "420 METHOD_FAILURE"
    | "421 DESTINATION_LOCKED"
    | "422 UNPROCESSABLE_ENTITY"
    | "423 LOCKED"
    | "424 FAILED_DEPENDENCY"
    | "425 TOO_EARLY"
    | "426 UPGRADE_REQUIRED"
    | "428 PRECONDITION_REQUIRED"
    | "429 TOO_MANY_REQUESTS"
    | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
    | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
    | "500 INTERNAL_SERVER_ERROR"
    | "501 NOT_IMPLEMENTED"
    | "502 BAD_GATEWAY"
    | "503 SERVICE_UNAVAILABLE"
    | "504 GATEWAY_TIMEOUT"
    | "505 HTTP_VERSION_NOT_SUPPORTED"
    | "506 VARIANT_ALSO_NEGOTIATES"
    | "507 INSUFFICIENT_STORAGE"
    | "508 LOOP_DETECTED"
    | "509 BANDWIDTH_LIMIT_EXCEEDED"
    | "510 NOT_EXTENDED"
    | "511 NETWORK_AUTHENTICATION_REQUIRED";
  /** @format int32 */
  statusCodeValue?: number;
}

/** SearchOrdersReq */
export interface SearchOrdersReq {
  /**
   * 创建时间结束
   * @format date-time
   */
  createdAtMax?: string;
  /**
   * 创建时间开始
   * @format date-time
   */
  createdAtMin?: string;
  /** @format int64 */
  customerShopId?: number;
  /** 支付状态---所有:any,已支付订单:paid,未支付订单:unpaid,已作废的订单:voided,在审核的订单:pending,已退款的订单:refunded,已授权的订单:authorized,部分支付订单:partially_paid,部分退款订单:partially_refunded; */
  financialStatus?: string;
  /** 物流状态---所有:any,部分发货订单:partial, 已发货和部分发货:shipped,未发货和部分发货:unshipped,未履行:unfulfilled,已履行:fulfilled; */
  fulfillmentStatus?: string;
  /** 订单状态---所有:any,未完结的订单:open,已关闭的订单:closed,已取消的订单:cancelled; */
  status?: string;
  /**
   * 更新时间结束
   * @format date-time
   */
  updatedAtMax?: string;
  /**
   * 更新时间开始
   * @format date-time
   */
  updatedAtMin?: string;
}

/** SearchProductsReq */
export interface SearchProductsReq {
  amazonAll?: boolean;
  /**
   * 创建时间结束
   * @format date-time
   */
  createdAtMax?: string;
  /**
   * 创建时间开始
   * @format date-time
   */
  createdAtMin?: string;
  /** @format int64 */
  customerShopId?: number;
  /**
   * 发布时间结束
   * @format date-time
   */
  publishedAtMax?: string;
  /**
   * 发布时间开始
   * @format date-time
   */
  publishedAtMin?: string;
  /** 发布状态：any：已发布；published：已发布；unpublished：未发布 */
  publishedStatus?: string;
  /** 商品状态：active：活跃；archived：存档，不再销售；draft：草稿，重复和未归档的产品设置为草稿 */
  status?: string;
  /** 商品名称 */
  title?: string;
  /**
   * 更新时间结束
   * @format date-time
   */
  updatedAtMax?: string;
  /**
   * 更新时间开始
   * @format date-time
   */
  updatedAtMin?: string;
}

/** SearchSourceOrder */
export interface SearchSourceOrder {
  /** @format int32 */
  addLogoFlag?: number;
  /** @format int32 */
  containTaxFlag?: number;
  /** @format int32 */
  customerExpectMinOrderQuantity?: number;
  customerSamplePrice?: number;
  defectiveDealMode?: string;
  defectiveDealModeJp?: string;
  /** @format int32 */
  deliveryPeriod?: number;
  fabric?: string;
  fabricJp?: string;
  fillSellPriceRemark?: string;
  gradientPrices?: GradientPrice[];
  /** @format int32 */
  minOrderQuantity?: number;
  /** @format int64 */
  oemSupplierId?: number;
  /** @format date-time */
  priceExpireTime?: string;
  productImg?: string;
  productName?: string;
  productNameZh?: string;
  productUrl?: string;
  purchaserUserName?: string;
  reportPurchasePriceRemark?: string;
  reportPurchasePriceRemarkJp?: string;
  risk?: string;
  riskJp?: string;
  samplePeriod?: number;
  samplePrice?: number;
  /** @format int64 */
  searchSourceOrderId?: number;
  searchSourceOrderNo?: string;
  /** @format int64 */
  searchSourceOrderSupplierPriceId?: number;
  /** @format int32 */
  sizeFlag?: number;
  /** @format int32 */
  specialMaterialFlag?: number;
  supplierName?: string;
}

/** SelectShopOrderItemsResp */
export interface SelectShopOrderItemsResp {
  /** @format int32 */
  additionCheckType?: number;
  additionSnapshot?: ThirdShopItemAddition[];
  /** @format int32 */
  bindStatus?: number;
  /** @format int32 */
  brandAuthStatus?: number;
  /** @format int32 */
  brandHasReleased?: number;
  /** @format int64 */
  brandId?: number;
  /** @format int32 */
  brandStatus?: number;
  combinationSubSnapshot?: CombinationSubProduct[];
  /** @format int32 */
  errorCode?: number;
  /** @format int32 */
  itemQuantity?: number;
  platformItemSku?: PlatformItemSkuResp;
  /** @format int64 */
  shopOrderId?: number;
  /** @format int64 */
  shopOrderItemId?: number;
  thirdItemSku?: ThirdItemSkuResp;
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
}

/** SkuMapping */
export interface SkuMapping {
  mappingInfoList?: MappingInfo[];
  /** @format int64 */
  shopItemSkuId?: number;
}

/** SkuMappingInfo */
export interface SkuMappingInfo {
  /** @format int32 */
  mappingSeq?: number;
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
}

/** SubmitAdditionReq */
export interface SubmitAdditionReq {
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  additionId?: number;
  ingredientsSku?: string;
}

/** SyncAmazonProductRequest */
export interface SyncAmazonProductRequest {
  amazonSkuList?: string[];
}

/** TaskResp */
export interface TaskResp {
  errorCode?: string;
  errorMsg?: string;
  result?: object;
  status?: string;
}

/** TestOrderProcessReq */
export interface TestOrderProcessReq {
  /** @format int64 */
  authShopId?: number;
  orderIdList?: number[];
}

/** ThirdItemSkuResp */
export interface ThirdItemSkuResp {
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  thirdSkuCode?: string;
}

/** ThirdShopAuth */
export interface ThirdShopAuth {
  accessToken?: string;
  authStatus?: "CHECK_OK" | "EXPIRED" | "INVALID_TOKEN" | "OTHER_ERROR" | "TOKEN_SCOPE_LACKING";
  cipher?: string;
  clientId?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  nationCode?: string;
  refreshToken?: string;
  /** @format int64 */
  shopAuthId?: number;
  shopExt?: string;
  stationCode?: string;
  status?: "BIND" | "UNBIND";
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
  thirdShopId?: string;
  thirdShopName?: string;
  thirdShopUrl?: string;
  /** @format int64 */
  tokenExpireTime?: number;
}

/** ThirdShopAuthBindRequest */
export interface ThirdShopAuthBindRequest {
  accessToken?: string;
  code?: string;
  /** @format int64 */
  customerShopId?: number;
  sellingPartnerId?: string;
  /** @format int32 */
  thirdShopType?: number;
  url?: string;
}

/** ThirdShopAuthBindResp */
export interface ThirdShopAuthBindResp {
  bind?: boolean;
  /** @format int32 */
  thirdPlatformType?: number;
}

/** ThirdShopAuthUnBindRequest */
export interface ThirdShopAuthUnBindRequest {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  thirdShopType?: number;
}

/** ThirdShopItem */
export interface ThirdShopItem {
  /** @format int32 */
  additionCheckType?: number;
  additionCheckTypeList?: AdditionCheckTypePojo[];
  additionList?: ThirdShopItemAddition[];
  additions?: AdditionsPojo[];
  /** @format int32 */
  bindingCount?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  flag?: number;
  /** @format int64 */
  isDeleted?: number;
  itemExtra?: string;
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
  skuList?: ThirdShopItemSku[];
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
  thirdSalePrice?: number;
  thirdShopId?: string;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  unbindingCount?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ThirdShopItemAddition */
export interface ThirdShopItemAddition {
  /** @format int32 */
  additionConfigId?: number;
  additionExtra?: ThirdShopItemAdditionExtra;
  additionExtraName?: string;
  /** @format int32 */
  additionId?: number;
  /** @format int64 */
  id?: number;
  ingredientsSku?: string;
  /** @format int64 */
  shopItemId?: number;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  warehouseCode?: string;
}

/** ThirdShopItemAdditionExtra */
export interface ThirdShopItemAdditionExtra {
  additionName?: string;
  additionNameJp?: string;
}

/** ThirdShopItemBatchDeleteRequest */
export interface ThirdShopItemBatchDeleteRequest {
  shopItemIds?: number[];
}

/** ThirdShopItemBindRequest */
export interface ThirdShopItemBindRequest {
  productSku?: string;
  /** @format int32 */
  productType?: number;
  /** @format int64 */
  shopItemSkuId?: number;
}

/** ThirdShopItemDeleteRequest */
export interface ThirdShopItemDeleteRequest {
  /** @format int64 */
  shopItemSkuId?: number;
}

/** ThirdShopItemMappingRequest */
export interface ThirdShopItemMappingRequest {
  /** @format int64 */
  shopItemId?: number;
  skuMappingList?: SkuMapping[];
  unbindFlag?: boolean;
}

/** ThirdShopItemMappingResp */
export interface ThirdShopItemMappingResp {
  bindedShopSkuInfoList?: BindedShopSkuInfo[];
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
}

/** ThirdShopItemQueryRequest */
export interface ThirdShopItemQueryRequest {
  /** @format int32 */
  bindStatus?: number;
  itemRemark?: string;
  itemRemarkList?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  productTitle?: string;
  thirdItemName?: string;
}

/** ThirdShopItemResp */
export interface ThirdShopItemResp {
  additionCheckTypeList?: AdditionCheckTypePojo[];
  additions?: AdditionsPojo[];
  /** @format int32 */
  bindingCount?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
  skuList?: ThirdShopItemSkuResp[];
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSalePrice?: number;
  thirdShopId?: string;
  /** @format int32 */
  totalCount?: number;
  /** @format int32 */
  unbindingCount?: number;
}

/** ThirdShopItemSku */
export interface ThirdShopItemSku {
  /** @format int32 */
  additionCheckType?: number;
  additionList?: ThirdShopItemSkuAddition[];
  bindStatus?: "UNBINDING" | "BINDING" | "BIND_ERROR";
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  itemRemark?: string;
  /** @format int32 */
  mappingCount?: number;
  productCode?: string;
  productSku?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  skuMappingList?: ThirdShopItemSkuMapping[];
  skuPrice?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
  thirdSalePrice?: number;
  thirdSkuCode?: string;
  thirdSkuExtra?: string;
  thirdSkuImage?: string;
  unifiedPlatformProduct?: UnifiedPlatformProduct;
  /** @format date-time */
  updateTime?: string;
  variationIdentifier?: string;
}

/** ThirdShopItemSkuAddition */
export interface ThirdShopItemSkuAddition {
  /** @format int32 */
  additionConfigId?: number;
  additionExtra?: ThirdShopItemAdditionExtra;
  additionExtraName?: string;
  /** @format int32 */
  additionId?: number;
  /** @format int64 */
  id?: number;
  ingredientsSku?: string;
  /** @format int64 */
  shopItemSkuId?: number;
  /** @format int32 */
  spotCheckFlag?: number;
  spotCheckRatio?: number;
  warehouseCode?: string;
}

/** ThirdShopItemSkuMapping */
export interface ThirdShopItemSkuMapping {
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerShopId?: number;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  isDeleted?: number;
  /** @format int32 */
  mappingSeq?: number;
  productCode?: string;
  productCountry?: string;
  productSku?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemCode?: string;
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
  thirdSkuCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** ThirdShopItemSkuMappingResp */
export interface ThirdShopItemSkuMappingResp {
  /** @format int64 */
  customerShopId?: number;
  /** @format int32 */
  mappingSeq?: number;
  productCode?: string;
  productSku?: string;
  /** @format int32 */
  productType?: number;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemCode?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSkuCode?: string;
}

/** ThirdShopItemSkuResp */
export interface ThirdShopItemSkuResp {
  /** @format int32 */
  additionCheckType?: number;
  /** @format int32 */
  bindStatus?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  itemRemark?: string;
  /** @format int32 */
  mappingCount?: number;
  /** @format int64 */
  shopItemId?: number;
  /** @format int64 */
  shopItemSkuId?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  /** @format int32 */
  thirdPlatformType?: number;
  thirdSalePrice?: number;
  thirdSkuCode?: string;
  thirdSkuImage?: string;
}

/** ThirdShopItemUnbindRequest */
export interface ThirdShopItemUnbindRequest {
  /** @format int64 */
  shopItemSkuId?: number;
}

/** ThirdShopOrder */
export interface ThirdShopOrder {
  allUnBindFlag?: boolean;
  /** @format int32 */
  createOrderNum?: number;
  currency?: string;
  /** @format int64 */
  customerId?: number;
  /** @format int64 */
  customerShopId?: number;
  deliveryAdditionList?: ThirdShopOrderDeliveryAddition[];
  deliveryAdditions?: DeliveryAdditionsPojo[];
  distribution?: string;
  errorCode?: string;
  errorMsg?: string;
  /** @format int64 */
  id?: number;
  /** @format int64 */
  intShipConfigId?: number;
  intShipConfigList?: IntShipConfigPojo[];
  /** @format int32 */
  isDeleted?: number;
  /** @format int32 */
  isReturnLogisticsNo?: number;
  /** @format int32 */
  itemQuantity?: number;
  metadata?: string;
  /** @format int32 */
  noCreateOrderNum?: number;
  orderAmount?: number;
  orderItems?: ThirdShopOrderItem[];
  orderSyncStatus?: "NOT_CREATE_ORDER" | "CREATE_ORDER_SUCCESS" | "CREATE_ORDERING" | "CREATE_ORDER_FAIL";
  partBindFlag?: boolean;
  /** @format int32 */
  payStatus?: number;
  /** @format int64 */
  platformOrderId?: number;
  platformOrderList?: PlatformOrderVO[];
  platformOrderNo?: string;
  priceFloatPercent?: number;
  productCountries?: string[];
  receiver?: ThirdShopOrderReceiver;
  /** @format int64 */
  shopOrderId?: number;
  /** @format date-time */
  shopOrderTime?: string;
  thirdOrderName?: string;
  thirdOrderNo?: string;
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
  thirdShopId?: string;
}

/** ThirdShopOrderDeliveryAddition */
export interface ThirdShopOrderDeliveryAddition {
  /** @format int32 */
  additionCode?: number;
  /** @format int32 */
  additionConfigId?: number;
  /** @format int32 */
  additionId?: number;
  additionName?: string;
  additionNameJp?: string;
  ingredientsName?: string;
  ingredientsNameJp?: string;
  ingredientsSku?: string;
  /** @format int64 */
  shopOrderId?: number;
  warehouseCode?: string;
}

/** ThirdShopOrderItem */
export interface ThirdShopOrderItem {
  /** @format int32 */
  additionCheckType?: number;
  additionSnapshot?: ThirdShopItemAddition[];
  combinationSubSnapshot?: string;
  /** @format int64 */
  customerShopId?: number;
  platformOrderNo?: string;
  productCode?: string;
  productCountry?: string;
  productSku?: string;
  productSnapshot?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
  /** @format int64 */
  searchSourceOrderId?: number;
  searchSourceOrderNo?: string;
  /** @format int32 */
  shipmentStatus?: number;
  /** @format int64 */
  shopOrderId?: number;
  /** @format int64 */
  shopOrderItemId?: number;
  thirdItemAmount?: number;
  thirdItemAttribute?: string;
  thirdItemCode?: string;
  thirdItemImage?: string;
  thirdItemName?: string;
  /** @format int32 */
  thirdItemQuantity?: number;
  thirdOrderItemId?: string;
  thirdPlatformType?: "OTHER" | "BASE" | "SHOPIFY" | "STORES" | "AMAZON" | "CAFE24" | "OPEN" | "TIKTOK_SHOP";
  thirdSkuCode?: string;
  trackingNumber?: string;
  /** @format int32 */
  trackingNumberSyncStatus?: number;
}

/** ThirdShopOrderQueryResp */
export interface ThirdShopOrderQueryResp {
  allUnBindFlag?: boolean;
  currency?: string;
  deliveryAdditionalList?: ThirdShopOrderDeliveryAddition[];
  deliveryAdditions?: DeliveryAdditionsPojo[];
  distribution?: string;
  errorCode?: string;
  errorMessage?: string;
  /** @format int64 */
  intShipConfigId?: number;
  intShipConfigList?: IntShipConfigPojo[];
  /** @format int32 */
  isReturnLogisticsNo?: number;
  orderName?: string;
  /** @format int32 */
  orderSyncStatus?: number;
  partBindFlag?: boolean;
  /** @format int32 */
  payStatus?: number;
  /** @format int32 */
  placeOrder?: number;
  /** @format int64 */
  platformOrderId?: number;
  platformOrderList?: PlatformOrderVO[];
  platformOrderNo?: string;
  productCountries?: string[];
  /** @format int32 */
  quantity?: number;
  receiver?: ThirdShopOrderReceiver;
  shopOrderAmount?: number;
  /** @format int64 */
  shopOrderId?: number;
  shopOrderNo?: string;
  /** @format date-time */
  shopOrderTime?: string;
}

/** ThirdShopOrderReceiver */
export interface ThirdShopOrderReceiver {
  address?: string;
  city?: string;
  clearanceCode?: string;
  country?: string;
  countryCode?: string;
  countryId?: string;
  district?: string;
  email?: string;
  name?: string;
  phone?: string;
  postalCode?: string;
  province?: string;
}

/** ThirdShopOrderSkuDTO */
export interface ThirdShopOrderSkuDTO {
  itemRemark?: string;
  thirdItemAttribute?: string;
}

/** TiktokAuthRequest */
export interface TiktokAuthRequest {
  appKey?: string;
  code?: string;
}

/** TiktokShopWebhookRequestDTO */
export interface TiktokShopWebhookRequestDTO {
  data?: Record<string, object>;
  shop_id?: string;
  /** @format int64 */
  timestamp?: number;
  tts_notification_id?: string;
  /** @format int32 */
  type?: number;
}

/**
 * TransportDetailInput
 * Information required to create an Amazon-partnered carrier shipping estimate, or to alert the Amazon fulfillment center to the arrival of an inbound shipment by a non-Amazon-partnered carrier.
 */
export interface TransportDetailInput {
  /** Information that you provide to Amazon about a Less Than Truckload/Full Truckload (LTL/FTL) shipment by a carrier that has not partnered with Amazon. */
  nonPartneredLtlData?: NonPartneredLtlDataInput;
  /** Information that you provide to Amazon about a Small Parcel shipment shipped by a carrier that has not partnered with Amazon. */
  nonPartneredSmallParcelData?: NonPartneredSmallParcelDataInput;
  /** Information that is required by an Amazon-partnered carrier to ship a Less Than Truckload/Full Truckload (LTL/FTL) inbound shipment. */
  partneredLtlData?: PartneredLtlDataInput;
  /** Information that is required by an Amazon-partnered carrier to ship a Small Parcel inbound shipment. */
  partneredSmallParcelData?: PartneredSmallParcelDataInput;
}

/**
 * TransportResult
 * The workflow status for a shipment with an Amazon-partnered carrier.
 */
export interface TransportResult {
  /** An error code that identifies the type of error that occured. */
  errorCode?: string;
  /** A message that describes the error condition. */
  errorDescription?: string;
  transportStatus:
    | "WORKING"
    | "ESTIMATING"
    | "ESTIMATED"
    | "ERROR_ON_ESTIMATING"
    | "CONFIRMING"
    | "CONFIRMED"
    | "ERROR_ON_CONFIRMING"
    | "VOIDING"
    | "VOIDED"
    | "ERROR_IN_VOIDING"
    | "ERROR";
}

/** UnifiedPlatformProduct */
export interface UnifiedPlatformProduct {
  combinationPlatformProduct?: CombinationPlatformProduct;
  commonPlatformProduct?: CommonPlatformProduct;
  oemPlatformProduct?: OemPlatformProduct;
  productCountry?: string;
  productType?: "COMMONT_PRODUCT" | "OEM_PRODUCT" | "COMBINATION_PRODUCT";
}

/** UpdateAdditionReqDTO */
export interface UpdateAdditionReqDTO {
  /** @format int64 */
  customerShopId?: number;
  mappingList?: AdditionUpdatePojo[];
  newWarehouseCode?: string;
  oldWarehouseCode?: string;
}

/** UpdateInboundShipmentReq */
export interface UpdateInboundShipmentReq {
  /** @format int64 */
  customerShopId?: number;
  /** The request schema for an inbound shipment. */
  inboundShipmentRequest?: InboundShipmentRequest;
  shipmentId?: string;
}

/** UpdateInboundShipmentResp */
export interface UpdateInboundShipmentResp {
  amazonResponseBody?: AmazonResponseBody;
  shipmentId?: string;
  success?: boolean;
}

/** UpdateItemAdditionRequest */
export interface UpdateItemAdditionRequest {
  additionList?: ItemAdditionDTO[];
  /** @format int32 */
  needAdditionalFlag?: number;
  shopItemIds?: number[];
  /** 编辑的附加项所在仓库 */
  warehouseCode?: string;
}

/** UpdateItemRemarkRequest */
export interface UpdateItemRemarkRequest {
  itemRemark?: string;
  /** @format int64 */
  shopItemId?: number;
}

/** UpdateItemSkuAdditionRequest */
export interface UpdateItemSkuAdditionRequest {
  additionList?: ItemAdditionDTO[];
  /** @format int32 */
  needAdditionalFlag?: number;
  shopItemSkuIds?: number[];
  warehouseCode?: string;
}

/** UpdateOrderItemAdditionRequest */
export interface UpdateOrderItemAdditionRequest {
  additionList?: ItemAdditionDTO[];
  /** @format int32 */
  needAdditionalFlag?: number;
  /** @format int64 */
  shopOrderItemId?: number;
  warehouseCode?: string;
}

/** UpdateShipmentBoxReq */
export interface UpdateShipmentBoxReq {
  boxInputList?: BoxInput[];
  /** @format int64 */
  customerShopId?: number;
  planNo?: string;
  shipmentId?: string;
}

/** UpdateShopOrderReceiverRequest */
export interface UpdateShopOrderReceiverRequest {
  clearanceCode?: string;
  country?: string;
  countryCode?: string;
  countryId?: string;
  shopOrderAddress?: string;
  shopOrderCity?: string;
  shopOrderCustomerName?: string;
  shopOrderDistrict?: string;
  shopOrderEmail?: string;
  /** @format int64 */
  shopOrderId?: number;
  shopOrderPostalCode?: string;
  shopOrderProvince?: string;
  shopOrderTel?: string;
}

/** UploadCartonContentsFeedReq */
export interface UploadCartonContentsFeedReq {
  createXmlVO?: CreateXmlVO;
  createXmlVOs?: CreateXmlVO[];
  /** @format int64 */
  customerShopId?: number;
  planNo?: string;
}

/** UploadCartonResp */
export interface UploadCartonResp {
  /** A list of error responses returned when a request is unsuccessful. */
  errors?: ErrorList;
  feedId?: string;
  feedType?: string;
  processingStatus?: "CANCELLED" | "DONE" | "FATAL" | "IN_PROGRESS" | "IN_QUEUE";
}

/**
 * Weight
 * The weight of the package.
 */
export interface Weight {
  unit: "pounds" | "kilograms";
  /** The weight value. */
  value: number;
}

/** BizResponse«ApiShopInfoResp» */
export interface BizResponseApiShopInfoResp {
  code?: string;
  data?: ApiShopInfoResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CreateInboundShipmentPlanResp» */
export interface BizResponseCreateInboundShipmentPlanResp {
  code?: string;
  data?: CreateInboundShipmentPlanResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CreateInboundShipmentResp» */
export interface BizResponseCreateInboundShipmentResp {
  code?: string;
  data?: CreateInboundShipmentResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerShopAuthResp» */
export interface BizResponseCustomerShopAuthResp {
  code?: string;
  data?: CustomerShopAuthResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«GetLabelResp» */
export interface BizResponseGetLabelResp {
  code?: string;
  data?: GetLabelResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«GetUploadStatusResp» */
export interface BizResponseGetUploadStatusResp {
  code?: string;
  data?: GetUploadStatusResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«LastUpdateTimeResult» */
export interface BizResponseLastUpdateTimeResult {
  code?: string;
  data?: LastUpdateTimeResult;
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«AmazonProductResp»» */
export interface BizResponseListAmazonProductResp {
  code?: string;
  data?: AmazonProductResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«AmazonProduct»» */
export interface BizResponseListAmazonProduct {
  code?: string;
  data?: AmazonProduct[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ApiShopInfoResp»» */
export interface BizResponseListApiShopInfoResp {
  code?: string;
  data?: ApiShopInfoResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerShopAuthResp»» */
export interface BizResponseListCustomerShopAuthResp {
  code?: string;
  data?: CustomerShopAuthResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ItemSkuMappingResp»» */
export interface BizResponseListItemSkuMappingResp {
  code?: string;
  data?: ItemSkuMappingResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ManualCreateOrderResult»» */
export interface BizResponseListManualCreateOrderResult {
  code?: string;
  data?: ManualCreateOrderResult[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«OpenOrderRespDTO»» */
export interface BizResponseListOpenOrderRespDTO {
  code?: string;
  data?: OpenOrderRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«PlatformLogisticsResp»» */
export interface BizResponseListPlatformLogisticsResp {
  code?: string;
  data?: PlatformLogisticsResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ReplenishPlanResp»» */
export interface BizResponseListReplenishPlanResp {
  code?: string;
  data?: ReplenishPlanResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SelectShopOrderItemsResp»» */
export interface BizResponseListSelectShopOrderItemsResp {
  code?: string;
  data?: SelectShopOrderItemsResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopItemSkuResp»» */
export interface BizResponseListThirdShopItemSkuResp {
  code?: string;
  data?: ThirdShopItemSkuResp[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopItem»» */
export interface BizResponseListThirdShopItem {
  code?: string;
  data?: ThirdShopItem[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ThirdShopOrder»» */
export interface BizResponseListThirdShopOrder {
  code?: string;
  data?: ThirdShopOrder[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«string»» */
export interface BizResponseListString {
  code?: string;
  data?: string[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«AmazonProduct»» */
export interface BizResponsePageResultAmazonProduct {
  code?: string;
  data?: PageResultAmazonProduct;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«OnTheWayStockQueryResoDTO»» */
export interface BizResponsePageResultOnTheWayStockQueryResoDTO {
  code?: string;
  data?: PageResultOnTheWayStockQueryResoDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ReplenishPlanResp»» */
export interface BizResponsePageResultReplenishPlanResp {
  code?: string;
  data?: PageResultReplenishPlanResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ThirdShopItemResp»» */
export interface BizResponsePageResultThirdShopItemResp {
  code?: string;
  data?: PageResultThirdShopItemResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ThirdShopOrderQueryResp»» */
export interface BizResponsePageResultThirdShopOrderQueryResp {
  code?: string;
  data?: PageResultThirdShopOrderQueryResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PutTransportDetailsResp» */
export interface BizResponsePutTransportDetailsResp {
  code?: string;
  data?: PutTransportDetailsResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«QueryOrderCountRespDTO» */
export interface BizResponseQueryOrderCountRespDTO {
  code?: string;
  data?: QueryOrderCountRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ReplenishPlanResp» */
export interface BizResponseReplenishPlanResp {
  code?: string;
  data?: ReplenishPlanResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«TaskResp» */
export interface BizResponseTaskResp {
  code?: string;
  data?: TaskResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopAuthBindResp» */
export interface BizResponseThirdShopAuthBindResp {
  code?: string;
  data?: ThirdShopAuthBindResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopItemMappingResp» */
export interface BizResponseThirdShopItemMappingResp {
  code?: string;
  data?: ThirdShopItemMappingResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopItemResp» */
export interface BizResponseThirdShopItemResp {
  code?: string;
  data?: ThirdShopItemResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopItemSkuResp» */
export interface BizResponseThirdShopItemSkuResp {
  code?: string;
  data?: ThirdShopItemSkuResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ThirdShopOrderSkuDTO» */
export interface BizResponseThirdShopOrderSkuDTO {
  code?: string;
  data?: ThirdShopOrderSkuDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«UpdateInboundShipmentResp» */
export interface BizResponseUpdateInboundShipmentResp {
  code?: string;
  data?: UpdateInboundShipmentResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«UploadCartonResp» */
export interface BizResponseUploadCartonResp {
  code?: string;
  data?: UploadCartonResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Void» */
export interface BizResponseVoid {
  code?: string;
  msg?: string;
  success?: boolean;
}

/** BizResponse«boolean» */
export interface BizResponseBoolean {
  code?: string;
  data?: boolean;
  msg?: string;
  success?: boolean;
}

/** BizResponse«long» */
export interface BizResponseLong {
  code?: string;
  /** @format int64 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«object» */
export interface BizResponseObject {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/** PageResult«AmazonProduct» */
export interface PageResultAmazonProduct {
  /** @format int64 */
  current?: number;
  records?: AmazonProduct[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«OnTheWayStockQueryResoDTO» */
export interface PageResultOnTheWayStockQueryResoDTO {
  /** @format int64 */
  current?: number;
  records?: OnTheWayStockQueryResoDTO[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ReplenishPlanResp» */
export interface PageResultReplenishPlanResp {
  /** @format int64 */
  current?: number;
  records?: ReplenishPlanResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ThirdShopItemResp» */
export interface PageResultThirdShopItemResp {
  /** @format int64 */
  current?: number;
  records?: ThirdShopItemResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ThirdShopOrderQueryResp» */
export interface PageResultThirdShopOrderQueryResp {
  /** @format int64 */
  current?: number;
  records?: ThirdShopOrderQueryResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

import axios, { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "//master-gateway.theckb.com:443/api",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title API文档
 * @version v1.0.0
 * @baseUrl //master-gateway.theckb.com:443/api
 * @contact 史尼芙 (https://www.taobaockb.com/)
 *
 * 史尼芙API文档
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  probe = {
    /**
     * No description
     *
     * @tags livens-probe-controller
     * @name Test
     * @summary 执行一次健康检查探针
     * @request GET:/Probe/test
     */
    test: (params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/Probe/test`,
        method: "GET",
        ...params,
      }),
  };
  actuator1 = {
    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo
     * @summary jvmInfo
     * @request GET:/actuator1/jvmInfo
     */
    jvmInfo: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name HeadActuator1
     * @summary jvmInfo
     * @request HEAD:/actuator1/jvmInfo
     */
    headActuator1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo2
     * @summary jvmInfo
     * @request POST:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo2: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo3
     * @summary jvmInfo
     * @request PUT:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo3: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo4
     * @summary jvmInfo
     * @request DELETE:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo4: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name OptionsActuator1
     * @summary jvmInfo
     * @request OPTIONS:/actuator1/jvmInfo
     */
    optionsActuator1: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags monitor-controller
     * @name JvmInfo5
     * @summary jvmInfo
     * @request PATCH:/actuator1/jvmInfo
     * @originalName jvmInfo
     * @duplicate
     */
    jvmInfo5: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/actuator1/jvmInfo`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),
  };
  addition = {
    /**
     * No description
     *
     * @tags api-addition-client-impl
     * @name UpdateAllConfigId
     * @summary updateAllConfigId
     * @request POST:/addition/updateAllConfigId
     */
    updateAllConfigId: (reqDTO: UpdateAdditionReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/addition/updateAllConfigId`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  amazon = {
    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductGetAmazonProductByMsku
     * @summary getAmazonProductByMsku
     * @request POST:/amazon/product/getAmazonProductByMsku
     */
    productGetAmazonProductByMsku: (req: GetAmazonProductByMskuRequest, params: RequestParams = {}) =>
      this.request<BizResponseListAmazonProduct, any>({
        path: `/amazon/product/getAmazonProductByMsku`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductPage
     * @summary pageAmazonProduct
     * @request POST:/amazon/product/page
     */
    productPage: (req: QueryAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultAmazonProduct, any>({
        path: `/amazon/product/page`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductRemove
     * @summary remove
     * @request POST:/amazon/product/remove
     */
    productRemove: (req: RemoveAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/amazon/product/remove`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags amazon-product-sku-controller
     * @name ProductSync
     * @summary sync
     * @request POST:/amazon/product/sync
     */
    productSync: (req: SyncAmazonProductRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/amazon/product/sync`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  amazonProduct = {
    /**
     * No description
     *
     * @tags amazon-product-sku-client-impl
     * @name QueryProducts
     * @summary queryProducts
     * @request POST:/amazonProduct/queryProducts
     */
    queryProducts: (req: QueryAmazonProductReq, params: RequestParams = {}) =>
      this.request<BizResponseListAmazonProductResp, any>({
        path: `/amazonProduct/queryProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  cafe24 = {
    /**
     * No description
     *
     * @tags cafe-24-app-controller
     * @name AuthCafe24
     * @summary authCafe24
     * @request POST:/cafe24/authCafe24
     */
    authCafe24: (request: Cafe24AuthRequest, params: RequestParams = {}) =>
      this.request<BizResponseLong, any>({
        path: `/cafe24/authCafe24`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cafe-24-app-controller
     * @name InstallApp
     * @summary installApp
     * @request GET:/cafe24/installApp
     */
    installApp: (
      query: {
        /** code */
        code: string;
        /** state */
        state: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/cafe24/installApp`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags cafe-24-app-controller
     * @name InstallAppRequest
     * @summary installAppRequest
     * @request GET:/cafe24/installAppRequest
     */
    installAppRequest: (
      query: {
        /** mall_id */
        mall_id: string;
        /**
         * shop_no
         * @format int32
         */
        shop_no: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/cafe24/installAppRequest`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  crossBorder = {
    /**
     * No description
     *
     * @tags item
     * @name ItemAdd
     * @summary create product
     * @request POST:/crossBorder/item/add
     */
    itemAdd: (addOpenItemReqDTO: AddOpenItemReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/crossBorder/item/add`,
        method: "POST",
        body: addOpenItemReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags order
     * @name OrderCreate
     * @summary create order
     * @request POST:/crossBorder/order/create
     */
    orderCreate: (createOrderReqDTO: CreateOrderReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/crossBorder/order/create`,
        method: "POST",
        body: createOrderReqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags order
     * @name OrderGet
     * @summary get order
     * @request POST:/crossBorder/order/get
     */
    orderGet: (getOrderReqDTO: GetOrderReqDTO, params: RequestParams = {}) =>
      this.request<BizResponseListOpenOrderRespDTO, any>({
        path: `/crossBorder/order/get`,
        method: "POST",
        body: getOrderReqDTO,
        type: ContentType.Json,
        ...params,
      }),
  };
  getTaskResult = {
    /**
     * No description
     *
     * @tags task-controller
     * @name GetTaskResult
     * @summary getTask
     * @request GET:/getTaskResult
     */
    getTaskResult: (
      query: {
        /** taskId */
        taskId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseTaskResp, any>({
        path: `/getTaskResult`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  inbound = {
    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name CancelInboundShipment
     * @summary cancelInboundShipment
     * @request GET:/inbound/cancelInboundShipment
     */
    cancelInboundShipment: (
      query: {
        /** planNo */
        planNo: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/inbound/cancelInboundShipment`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name CreateShipment
     * @summary createInboundShipment
     * @request POST:/inbound/create/shipment
     */
    createShipment: (request: CreateInboundShipmentReq, params: RequestParams = {}) =>
      this.request<BizResponseCreateInboundShipmentResp, any>({
        path: `/inbound/create/shipment`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name CreateShipmentPlan
     * @summary createInboundShipmentPlan
     * @request POST:/inbound/create/shipment/plan
     */
    createShipmentPlan: (request: CreateInboundShipmentPlanReq, params: RequestParams = {}) =>
      this.request<BizResponseCreateInboundShipmentPlanResp, any>({
        path: `/inbound/create/shipment/plan`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name GetLabel
     * @summary getLabel
     * @request POST:/inbound/get/label
     */
    getLabel: (request: GetLabelReq, params: RequestParams = {}) =>
      this.request<BizResponseGetLabelResp, any>({
        path: `/inbound/get/label`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name PutTransportDetails
     * @summary putTransportDetails
     * @request POST:/inbound/put/transport/details
     */
    putTransportDetails: (request: PutTransportDetailsReq, params: RequestParams = {}) =>
      this.request<BizResponsePutTransportDetailsResp, any>({
        path: `/inbound/put/transport/details`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UpdateShipment
     * @summary updateInboundShipment
     * @request POST:/inbound/update/shipment
     */
    updateShipment: (request: UpdateInboundShipmentReq, params: RequestParams = {}) =>
      this.request<BizResponseUpdateInboundShipmentResp, any>({
        path: `/inbound/update/shipment`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UpdateShipmentBox
     * @summary updateShipmentBox
     * @request POST:/inbound/update/shipment/box
     */
    updateShipmentBox: (req: UpdateShipmentBoxReq, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/inbound/update/shipment/box`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UploadCartonContents
     * @summary uploadCartonContents
     * @request POST:/inbound/upload/carton/contents
     */
    uploadCartonContents: (request: UploadCartonContentsFeedReq, params: RequestParams = {}) =>
      this.request<BizResponseUploadCartonResp, any>({
        path: `/inbound/upload/carton/contents`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UploadCartonSizeInfo
     * @summary uploadCartonSizeInfo
     * @request POST:/inbound/upload/carton/size/info
     */
    uploadCartonSizeInfo: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
        /** shipmentId */
        shipmentId?: string;
      },
      data: {
        /** file */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseUploadCartonResp, any>({
        path: `/inbound/upload/carton/size/info`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags inbound-shipment-client-impl
     * @name UploadStatus
     * @summary getUploadStatus
     * @request POST:/inbound/upload/status
     */
    uploadStatus: (request: GetUploadStatusReq, params: RequestParams = {}) =>
      this.request<BizResponseGetUploadStatusResp, any>({
        path: `/inbound/upload/status`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),
  };
  logisticsPlatform = {
    /**
     * No description
     *
     * @tags logistics-platform-client-impl
     * @name GetByIds
     * @summary getByIds
     * @request GET:/logisticsPlatform/getByIds
     */
    getByIds: (
      query: {
        /** logisticsIdList */
        logisticsIdList: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListPlatformLogisticsResp, any>({
        path: `/logisticsPlatform/getByIds`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags logistics-platform-client-impl
     * @name GetByPlatformType
     * @summary getByPlatformType
     * @request GET:/logisticsPlatform/getByPlatformType
     */
    getByPlatformType: (
      query?: {
        /**
         * platformType
         * @format int32
         */
        platformType?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListPlatformLogisticsResp, any>({
        path: `/logisticsPlatform/getByPlatformType`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  manage = {
    /**
     * No description
     *
     * @tags 补货计划(后台)
     * @name ReplenishPlanPage
     * @summary 补货计划分页
     * @request GET:/manage/replenishPlan/page
     */
    replenishPlanPage: (
      query?: {
        amazonMsku?: string;
        amazonMskuList?: string[];
        /** @format int64 */
        customerId?: number;
        customerName?: string;
        /** @format int64 */
        customerShopId?: number;
        customerShopName?: string;
        keywordName?: string;
        /** @format int32 */
        pageNum?: number;
        /** @format int32 */
        pageSize?: number;
        /** @format int32 */
        planStatus?: number;
        productSku?: string;
        productSkuList?: string[];
        shipmentId?: string;
        shipmentIdList?: string[];
        unificationCustomerFullName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponsePageResultReplenishPlanResp, any>({
        path: `/manage/replenishPlan/page`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  ops = {
    /**
     * No description
     *
     * @tags ops-amazon-controller
     * @name AmazonSearchProducts
     * @summary searchProducts
     * @request POST:/ops/amazon/searchProducts
     */
    amazonSearchProducts: (req: SearchProductsReq, params: RequestParams = {}) =>
      this.request<BizResponseListAmazonProduct, any>({
        path: `/ops/amazon/searchProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-base-controller
     * @name BaseSearchOrders
     * @summary searchOrders
     * @request POST:/ops/base/searchOrders
     */
    baseSearchOrders: (req: SearchOrdersReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopOrder, any>({
        path: `/ops/base/searchOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-base-controller
     * @name BaseSearchProducts
     * @summary searchProducts
     * @request POST:/ops/base/searchProducts
     */
    baseSearchProducts: (req: SearchProductsReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopItem, any>({
        path: `/ops/base/searchProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-shopify-controller
     * @name ShopifySearchOrders
     * @summary searchOrders
     * @request POST:/ops/shopify/searchOrders
     */
    shopifySearchOrders: (req: SearchOrdersReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopOrder, any>({
        path: `/ops/shopify/searchOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ops-shopify-controller
     * @name ShopifySearchProducts
     * @summary searchProducts
     * @request POST:/ops/shopify/searchProducts
     */
    shopifySearchProducts: (req: SearchProductsReq, params: RequestParams = {}) =>
      this.request<BizResponseListThirdShopItem, any>({
        path: `/ops/shopify/searchProducts`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  orderProcess = {
    /**
     * No description
     *
     * @tags 测试管理
     * @name TestBaseRefresh
     * @summary baseRefresh
     * @request POST:/orderProcess/test/baseRefresh
     */
    testBaseRefresh: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/orderProcess/test/baseRefresh`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 测试管理
     * @name TestTestCreateOrder
     * @summary testCreateOrder
     * @request POST:/orderProcess/test/testCreateOrder
     */
    testTestCreateOrder: (orderIdList: number[], params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/orderProcess/test/testCreateOrder`,
        method: "POST",
        body: orderIdList,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 测试管理
     * @name TestTestOrderProcess
     * @summary testOrderProcess
     * @request POST:/orderProcess/test/testOrderProcess
     */
    testTestOrderProcess: (testOrderProcessReq: TestOrderProcessReq, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/orderProcess/test/testOrderProcess`,
        method: "POST",
        body: testOrderProcessReq,
        type: ContentType.Json,
        ...params,
      }),
  };
  replenishPlan = {
    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name CancelPlan
     * @summary cancelPlan
     * @request POST:/replenishPlan/cancelPlan
     */
    cancelPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/cancelPlan`,
        method: "POST",
        body: shipmentId,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name CheckDiscardPlan
     * @summary checkDiscardPlan
     * @request GET:/replenishPlan/check/discardPlan
     */
    checkDiscardPlan: (
      query: {
        /** shipmentId */
        shipmentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListString, any>({
        path: `/replenishPlan/check/discardPlan`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan
     * @summary confirmPlan
     * @request GET:/replenishPlan/confirmPlan/{shipmentId}
     */
    confirmPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name HeadReplenishPlan
     * @summary confirmPlan
     * @request HEAD:/replenishPlan/confirmPlan/{shipmentId}
     */
    headReplenishPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan2
     * @summary confirmPlan
     * @request POST:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan2: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan3
     * @summary confirmPlan
     * @request PUT:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan3: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan4
     * @summary confirmPlan
     * @request DELETE:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan4: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name OptionsReplenishPlan
     * @summary confirmPlan
     * @request OPTIONS:/replenishPlan/confirmPlan/{shipmentId}
     */
    optionsReplenishPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name ConfirmPlan5
     * @summary confirmPlan
     * @request PATCH:/replenishPlan/confirmPlan/{shipmentId}
     * @originalName confirmPlan
     * @duplicate
     */
    confirmPlan5: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/confirmPlan/${shipmentId}`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name CreatePlan
     * @summary createPlan
     * @request POST:/replenishPlan/createPlan
     */
    createPlan: (reqDTO: CreateReplenishPlanReq, params: RequestParams = {}) =>
      this.request<BizResponseCreateInboundShipmentPlanResp, any>({
        path: `/replenishPlan/createPlan`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name DiscardPlan
     * @summary discardPlan
     * @request POST:/replenishPlan/discardPlan/{shipmentId}
     */
    discardPlan: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/discardPlan/${shipmentId}`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name GetProcessingReplenishPlanList
     * @summary getProcessingReplenishPlanList
     * @request POST:/replenishPlan/getProcessingReplenishPlanList
     */
    getProcessingReplenishPlanList: (amazonMsku: string, params: RequestParams = {}) =>
      this.request<BizResponseListReplenishPlanResp, any>({
        path: `/replenishPlan/getProcessingReplenishPlanList`,
        method: "POST",
        body: amazonMsku,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name GetReplenishPlan
     * @summary getReplenishPlan
     * @request POST:/replenishPlan/getReplenishPlan
     */
    getReplenishPlan: (
      query: {
        /** shipmentId */
        shipmentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseReplenishPlanResp, any>({
        path: `/replenishPlan/getReplenishPlan`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name NotifyDelivered
     * @summary notifyDelivered
     * @request POST:/replenishPlan/notifyDelivered
     */
    notifyDelivered: (shipmentId: string, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/replenishPlan/notifyDelivered`,
        method: "POST",
        body: shipmentId,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-controller
     * @name Page
     * @summary page
     * @request POST:/replenishPlan/page
     */
    page: (reqDTO: CustomerReplenishPlanReq, params: RequestParams = {}) =>
      this.request<BizResponsePageResultReplenishPlanResp, any>({
        path: `/replenishPlan/page`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags replenish-plan-client-impl
     * @name SelectReplenishPlanList
     * @summary selectReplenishPlanList
     * @request POST:/replenishPlan/selectReplenishPlanList
     */
    selectReplenishPlanList: (req: ReplenishPlanListReq, params: RequestParams = {}) =>
      this.request<BizResponseListReplenishPlanResp, any>({
        path: `/replenishPlan/selectReplenishPlanList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  shop = {
    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name GetAuth
     * @summary getCustomerShopAuth
     * @request GET:/shop/getAuth
     */
    getAuth: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseCustomerShopAuthResp, any>({
        path: `/shop/getAuth`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name GetCustomerAuthStatus
     * @summary getBaseCustomerAuthStatus
     * @request GET:/shop/getCustomerAuthStatus
     */
    getCustomerAuthStatus: (
      query: {
        /** customerShopIdSet */
        customerShopIdSet: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListCustomerShopAuthResp, any>({
        path: `/shop/getCustomerAuthStatus`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name ShopStat
     * @summary shopStat
     * @request GET:/shop/shopStat
     */
    shopStat: (
      query: {
        /** customerShopIdSet */
        customerShopIdSet: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListApiShopInfoResp, any>({
        path: `/shop/shopStat`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags api-shop-client-impl
     * @name SingleShopStat
     * @summary singleShopStat
     * @request GET:/shop/singleShopStat
     */
    singleShopStat: (
      query: {
        /**
         * customerShopId
         * @format int64
         */
        customerShopId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseApiShopInfoResp, any>({
        path: `/shop/singleShopStat`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  test = {
    /**
     * No description
     *
     * @tags test-controller
     * @name GetNacosData
     * @summary 获取nacos配置数据
     * @request GET:/test/get/nacos/data
     */
    getNacosData: (params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/test/get/nacos/data`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping
     * @summary ping
     * @request GET:/test/ping
     */
    ping: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name HeadTest
     * @summary ping
     * @request HEAD:/test/ping
     */
    headTest: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "HEAD",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping2
     * @summary ping
     * @request POST:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping2: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping3
     * @summary ping
     * @request PUT:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping3: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "PUT",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping4
     * @summary ping
     * @request DELETE:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping4: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name OptionsTest
     * @summary ping
     * @request OPTIONS:/test/ping
     */
    optionsTest: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "OPTIONS",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-controller
     * @name Ping5
     * @summary ping
     * @request PATCH:/test/ping
     * @originalName ping
     * @duplicate
     */
    ping5: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/test/ping`,
        method: "PATCH",
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopAuth = {
    /**
     * No description
     *
     * @tags 店铺管理
     * @name Bind
     * @summary 店铺绑定
     * @request GET:/thirdShopAuth/bind
     */
    bind: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name HeadThirdShopAuth
     * @summary 店铺绑定
     * @request HEAD:/thirdShopAuth/bind
     */
    headThirdShopAuth: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name Bind2
     * @summary 店铺绑定
     * @request POST:/thirdShopAuth/bind
     * @originalName bind
     * @duplicate
     */
    bind2: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name Bind3
     * @summary 店铺绑定
     * @request PUT:/thirdShopAuth/bind
     * @originalName bind
     * @duplicate
     */
    bind3: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name Bind4
     * @summary 店铺绑定
     * @request DELETE:/thirdShopAuth/bind
     * @originalName bind
     * @duplicate
     */
    bind4: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name OptionsThirdShopAuth
     * @summary 店铺绑定
     * @request OPTIONS:/thirdShopAuth/bind
     */
    optionsThirdShopAuth: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name Bind5
     * @summary 店铺绑定
     * @request PATCH:/thirdShopAuth/bind
     * @originalName bind
     * @duplicate
     */
    bind5: (req: ThirdShopAuthBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/bind`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name IsBind
     * @summary 店铺是否绑定过
     * @request GET:/thirdShopAuth/isBind
     */
    isBind: (params: RequestParams = {}) =>
      this.request<BizResponseThirdShopAuthBindResp, any>({
        path: `/thirdShopAuth/isBind`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind
     * @summary 店铺解绑
     * @request GET:/thirdShopAuth/unBind
     */
    unBind: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name HeadThirdShopAuth2
     * @summary 店铺解绑
     * @request HEAD:/thirdShopAuth/unBind
     * @originalName headThirdShopAuth
     * @duplicate
     */
    headThirdShopAuth2: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind2
     * @summary 店铺解绑
     * @request POST:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind2: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind3
     * @summary 店铺解绑
     * @request PUT:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind3: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind4
     * @summary 店铺解绑
     * @request DELETE:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind4: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name OptionsThirdShopAuth2
     * @summary 店铺解绑
     * @request OPTIONS:/thirdShopAuth/unBind
     * @originalName optionsThirdShopAuth
     * @duplicate
     */
    optionsThirdShopAuth2: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺管理
     * @name UnBind5
     * @summary 店铺解绑
     * @request PATCH:/thirdShopAuth/unBind
     * @originalName unBind
     * @duplicate
     */
    unBind5: (req: ThirdShopAuthUnBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopAuth/unBind`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopItem = {
    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name BatchDelete
     * @summary 批量删除店铺商品
     * @request POST:/thirdShopItem/batchDelete
     */
    batchDelete: (request: ThirdShopItemBatchDeleteRequest, params: RequestParams = {}) =>
      this.request<BizResponseObject, any>({
        path: `/thirdShopItem/batchDelete`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name BindSku
     * @summary 绑定店铺商品SKU
     * @request POST:/thirdShopItem/bindSku
     */
    bindSku: (request: ThirdShopItemBindRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/bindSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name DeleteItemSku
     * @summary 删除店铺商品sku
     * @request POST:/thirdShopItem/deleteItemSku
     */
    deleteItemSku: (request: ThirdShopItemDeleteRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/deleteItemSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name GetLastTime
     * @summary 获取商品上次更新时间
     * @request GET:/thirdShopItem/getLastTime
     */
    getLastTime: (params: RequestParams = {}) =>
      this.request<BizResponseLastUpdateTimeResult, any>({
        path: `/thirdShopItem/getLastTime`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name GetShopItemDetail
     * @summary 取得店铺商品详情
     * @request GET:/thirdShopItem/getShopItemDetail
     */
    getShopItemDetail: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdShopItemResp, any>({
        path: `/thirdShopItem/getShopItemDetail`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name HasAvailableTransportationNums
     * @summary 是否有可用的在途库存
     * @request POST:/thirdShopItem/hasAvailableTransportationNums
     */
    hasAvailableTransportationNums: (reqDTO: ListOnTheWayStockPageRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/hasAvailableTransportationNums`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name MappingSku
     * @summary 关联店铺商品SKU
     * @request POST:/thirdShopItem/mappingSku
     */
    mappingSku: (request: ThirdShopItemMappingRequest, params: RequestParams = {}) =>
      this.request<BizResponseThirdShopItemMappingResp, any>({
        path: `/thirdShopItem/mappingSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PageOnTheWayStock
     * @summary 分页获取在途库存列表
     * @request POST:/thirdShopItem/pageOnTheWayStock
     */
    pageOnTheWayStock: (reqDTO: ListOnTheWayStockPageRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultOnTheWayStockQueryResoDTO, any>({
        path: `/thirdShopItem/pageOnTheWayStock`,
        method: "POST",
        body: reqDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PageThirdShopItem
     * @summary 搜索第三方店铺商品
     * @request POST:/thirdShopItem/pageThirdShopItem
     */
    pageThirdShopItem: (request: ThirdShopItemQueryRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopItemResp, any>({
        path: `/thirdShopItem/pageThirdShopItem`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name PublishToShop
     * @summary 店铺商品一键上新-传输至店铺
     * @request POST:/thirdShopItem/publishToShop
     */
    publishToShop: (request: PublishItemToShopRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/publishToShop`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name QuerySkuList
     * @summary 店铺商品SKU列表
     * @request GET:/thirdShopItem/querySkuList
     */
    querySkuList: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListThirdShopItemSkuResp, any>({
        path: `/thirdShopItem/querySkuList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name RefreshItem
     * @summary 同步单个商品
     * @request GET:/thirdShopItem/refreshItem
     */
    refreshItem: (
      query: {
        /**
         * shopItemId
         * @format int64
         */
        shopItemId: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/refreshItem`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name SyncItems
     * @summary 同步全部商品
     * @request GET:/thirdShopItem/syncItems
     */
    syncItems: (params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/syncItems`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UnbindSku
     * @summary 解绑店铺商品SKU
     * @request POST:/thirdShopItem/unbindSku
     */
    unbindSku: (request: ThirdShopItemUnbindRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/unbindSku`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemAddition
     * @summary 编辑商品附加项
     * @request POST:/thirdShopItem/updateItemAddition
     */
    updateItemAddition: (request: UpdateItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/updateItemAddition`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemRemark
     * @summary 修改商品番号
     * @request POST:/thirdShopItem/updateItemRemark
     */
    updateItemRemark: (request: UpdateItemRemarkRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopItem/updateItemRemark`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 第三方店铺商品
     * @name UpdateItemSkuAddition
     * @summary 编辑商品sku附加项
     * @request POST:/thirdShopItem/updateItemSkuAddition
     */
    updateItemSkuAddition: (request: UpdateItemSkuAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopItem/updateItemSkuAddition`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopItemSku = {
    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name GetByThirdSkuCode
     * @summary getByThirdSkuCode
     * @request GET:/thirdShopItemSku/getByThirdSkuCode
     */
    getByThirdSkuCode: (
      query: {
        /** thirdSkuCode */
        thirdSkuCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdShopItemSkuResp, any>({
        path: `/thirdShopItemSku/getByThirdSkuCode`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-item-sku-client-impl
     * @name QuerySkuMappingList
     * @summary querySkuMappingList
     * @request POST:/thirdShopItemSku/querySkuMappingList
     */
    querySkuMappingList: (req: ItemSkuMappingQueryReq, params: RequestParams = {}) =>
      this.request<BizResponseListItemSkuMappingResp, any>({
        path: `/thirdShopItemSku/querySkuMappingList`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),
  };
  thirdShopOrder = {
    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name BatchUpdateSyncLogisticsNo
     * @summary batchUpdateSynLogisticsNo
     * @request POST:/thirdShopOrder/batchUpdateSyncLogisticsNo
     */
    batchUpdateSyncLogisticsNo: (
      batchUpdateSyncLogisticsNoReq: BatchUpdateSyncLogisticsNoReq,
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/batchUpdateSyncLogisticsNo`,
        method: "POST",
        body: batchUpdateSyncLogisticsNoReq,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders
     * @summary createShopOrder
     * @request GET:/thirdShopOrder/createPlatformOrders
     */
    createPlatformOrders: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder
     * @summary createShopOrder
     * @request HEAD:/thirdShopOrder/createPlatformOrders
     */
    headThirdShopOrder: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders2
     * @summary createShopOrder
     * @request POST:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders2: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders3
     * @summary createShopOrder
     * @request PUT:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders3: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders4
     * @summary createShopOrder
     * @request DELETE:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders4: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder
     * @summary createShopOrder
     * @request OPTIONS:/thirdShopOrder/createPlatformOrders
     */
    optionsThirdShopOrder: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name CreatePlatformOrders5
     * @summary createShopOrder
     * @request PATCH:/thirdShopOrder/createPlatformOrders
     * @originalName createPlatformOrders
     * @duplicate
     */
    createPlatformOrders5: (req: CreateShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseListManualCreateOrderResult, any>({
        path: `/thirdShopOrder/createPlatformOrders`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrder
     * @summary deleteShopOrder
     * @request POST:/thirdShopOrder/deleteShopOrder
     */
    deleteShopOrder: (req: DeleteShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem
     * @summary deleteShopOrderItem
     * @request GET:/thirdShopOrder/deleteShopOrderItem
     */
    deleteShopOrderItem: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder2
     * @summary deleteShopOrderItem
     * @request HEAD:/thirdShopOrder/deleteShopOrderItem
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder2: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem2
     * @summary deleteShopOrderItem
     * @request POST:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem2: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem3
     * @summary deleteShopOrderItem
     * @request PUT:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem3: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem4
     * @summary deleteShopOrderItem
     * @request DELETE:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem4: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder2
     * @summary deleteShopOrderItem
     * @request OPTIONS:/thirdShopOrder/deleteShopOrderItem
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder2: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name DeleteShopOrderItem5
     * @summary deleteShopOrderItem
     * @request PATCH:/thirdShopOrder/deleteShopOrderItem
     * @originalName deleteShopOrderItem
     * @duplicate
     */
    deleteShopOrderItem5: (req: DeleteShopOrderItemRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/deleteShopOrderItem`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-client-impl
     * @name Delivery
     * @summary delivery
     * @request POST:/thirdShopOrder/delivery
     */
    delivery: (dto: OrderDeliveryReq, params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/thirdShopOrder/delivery`,
        method: "POST",
        body: dto,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions
     * @summary editDeliveryAdditions
     * @request GET:/thirdShopOrder/editDeliveryAdditions
     */
    editDeliveryAdditions: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder3
     * @summary editDeliveryAdditions
     * @request HEAD:/thirdShopOrder/editDeliveryAdditions
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder3: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions2
     * @summary editDeliveryAdditions
     * @request POST:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions2: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions3
     * @summary editDeliveryAdditions
     * @request PUT:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions3: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions4
     * @summary editDeliveryAdditions
     * @request DELETE:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions4: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder3
     * @summary editDeliveryAdditions
     * @request OPTIONS:/thirdShopOrder/editDeliveryAdditions
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder3: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditDeliveryAdditions5
     * @summary editDeliveryAdditions
     * @request PATCH:/thirdShopOrder/editDeliveryAdditions
     * @originalName editDeliveryAdditions
     * @duplicate
     */
    editDeliveryAdditions5: (req: EditDeliveryAdditionsRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/editDeliveryAdditions`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig
     * @summary editIntShipConfig
     * @request GET:/thirdShopOrder/editIntShipConfig
     */
    editIntShipConfig: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder4
     * @summary editIntShipConfig
     * @request HEAD:/thirdShopOrder/editIntShipConfig
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder4: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig2
     * @summary editIntShipConfig
     * @request POST:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig2: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig3
     * @summary editIntShipConfig
     * @request PUT:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig3: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig4
     * @summary editIntShipConfig
     * @request DELETE:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig4: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder4
     * @summary editIntShipConfig
     * @request OPTIONS:/thirdShopOrder/editIntShipConfig
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder4: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name EditIntShipConfig5
     * @summary editIntShipConfig
     * @request PATCH:/thirdShopOrder/editIntShipConfig
     * @originalName editIntShipConfig
     * @duplicate
     */
    editIntShipConfig5: (req: EditIntShipConfigRequest, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/thirdShopOrder/editIntShipConfig`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name FixOrderReceiver
     * @summary fixOrderReceiver
     * @request POST:/thirdShopOrder/fixOrderReceiver
     */
    fixOrderReceiver: (params: RequestParams = {}) =>
      this.request<BizResponse, any>({
        path: `/thirdShopOrder/fixOrderReceiver`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetMissingItemOrderFlag
     * @summary 获取未关联下单店铺白名单标识
     * @request GET:/thirdShopOrder/getMissingItemOrderFlag
     */
    getMissingItemOrderFlag: (params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/getMissingItemOrderFlag`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList
     * @summary getShopOrderItemList
     * @request GET:/thirdShopOrder/getShopOrderItemList
     */
    getShopOrderItemList: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder5
     * @summary getShopOrderItemList
     * @request HEAD:/thirdShopOrder/getShopOrderItemList
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder5: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "HEAD",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList2
     * @summary getShopOrderItemList
     * @request POST:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList2: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList3
     * @summary getShopOrderItemList
     * @request PUT:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList3: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "PUT",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList4
     * @summary getShopOrderItemList
     * @request DELETE:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList4: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder5
     * @summary getShopOrderItemList
     * @request OPTIONS:/thirdShopOrder/getShopOrderItemList
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder5: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "OPTIONS",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name GetShopOrderItemList5
     * @summary getShopOrderItemList
     * @request PATCH:/thirdShopOrder/getShopOrderItemList
     * @originalName getShopOrderItemList
     * @duplicate
     */
    getShopOrderItemList5: (
      query?: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseListSelectShopOrderItemsResp, any>({
        path: `/thirdShopOrder/getShopOrderItemList`,
        method: "PATCH",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder
     * @summary manualSyncOrder
     * @request GET:/thirdShopOrder/manualSyncOrder
     */
    manualSyncOrder: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder6
     * @summary manualSyncOrder
     * @request HEAD:/thirdShopOrder/manualSyncOrder
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder6: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder2
     * @summary manualSyncOrder
     * @request POST:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder2: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder3
     * @summary manualSyncOrder
     * @request PUT:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder3: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder4
     * @summary manualSyncOrder
     * @request DELETE:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder4: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder6
     * @summary manualSyncOrder
     * @request OPTIONS:/thirdShopOrder/manualSyncOrder
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder6: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name ManualSyncOrder5
     * @summary manualSyncOrder
     * @request PATCH:/thirdShopOrder/manualSyncOrder
     * @originalName manualSyncOrder
     * @duplicate
     */
    manualSyncOrder5: (req: ManualSyncOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/manualSyncOrder`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryCount
     * @summary queryCount
     * @request GET:/thirdShopOrder/queryCount
     */
    queryCount: (params: RequestParams = {}) =>
      this.request<BizResponseQueryOrderCountRespDTO, any>({
        path: `/thirdShopOrder/queryCount`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder
     * @summary queryShopOrder
     * @request GET:/thirdShopOrder/queryShopOrder
     */
    queryShopOrder: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder7
     * @summary queryShopOrder
     * @request HEAD:/thirdShopOrder/queryShopOrder
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder7: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder2
     * @summary queryShopOrder
     * @request POST:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder2: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder3
     * @summary queryShopOrder
     * @request PUT:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder3: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder4
     * @summary queryShopOrder
     * @request DELETE:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder4: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder7
     * @summary queryShopOrder
     * @request OPTIONS:/thirdShopOrder/queryShopOrder
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder7: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryShopOrder5
     * @summary queryShopOrder
     * @request PATCH:/thirdShopOrder/queryShopOrder
     * @originalName queryShopOrder
     * @duplicate
     */
    queryShopOrder5: (req: QueryShopOrderRequest, params: RequestParams = {}) =>
      this.request<BizResponsePageResultThirdShopOrderQueryResp, any>({
        path: `/thirdShopOrder/queryShopOrder`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name QueryThirdShopItemSku
     * @summary queryThirdShopItemSku
     * @request GET:/thirdShopOrder/queryThirdShopItemSku
     */
    queryThirdShopItemSku: (
      query?: {
        /** 子订单系统单号 */
        orderCode?: string;
        /** 直行便订单编号 */
        platformOrderNo?: string;
        /** 平台sku */
        productSku?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseThirdShopOrderSkuDTO, any>({
        path: `/thirdShopOrder/queryThirdShopItemSku`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition
     * @summary updateOrderItemAddition
     * @request GET:/thirdShopOrder/updateOrderItemAddition
     */
    updateOrderItemAddition: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "GET",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder8
     * @summary updateOrderItemAddition
     * @request HEAD:/thirdShopOrder/updateOrderItemAddition
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder8: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "HEAD",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition2
     * @summary updateOrderItemAddition
     * @request POST:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition2: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition3
     * @summary updateOrderItemAddition
     * @request PUT:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition3: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "PUT",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition4
     * @summary updateOrderItemAddition
     * @request DELETE:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition4: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "DELETE",
        body: req,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder8
     * @summary updateOrderItemAddition
     * @request OPTIONS:/thirdShopOrder/updateOrderItemAddition
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder8: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "OPTIONS",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateOrderItemAddition5
     * @summary updateOrderItemAddition
     * @request PATCH:/thirdShopOrder/updateOrderItemAddition
     * @originalName updateOrderItemAddition
     * @duplicate
     */
    updateOrderItemAddition5: (req: UpdateOrderItemAdditionRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateOrderItemAddition`,
        method: "PATCH",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateShopOrderAddress
     * @summary updateShopOrderAddress
     * @request POST:/thirdShopOrder/updateShopOrderAddress
     */
    updateShopOrderAddress: (req: UpdateShopOrderReceiverRequest, params: RequestParams = {}) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateShopOrderAddress`,
        method: "POST",
        body: req,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo
     * @summary updateSynLogisticsNo
     * @request GET:/thirdShopOrder/updateSynLogisticsNo
     */
    updateSynLogisticsNo: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name HeadThirdShopOrder9
     * @summary updateSynLogisticsNo
     * @request HEAD:/thirdShopOrder/updateSynLogisticsNo
     * @originalName headThirdShopOrder
     * @duplicate
     */
    headThirdShopOrder9: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "HEAD",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo2
     * @summary updateSynLogisticsNo
     * @request POST:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo2: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "POST",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo3
     * @summary updateSynLogisticsNo
     * @request PUT:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo3: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "PUT",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo4
     * @summary updateSynLogisticsNo
     * @request DELETE:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo4: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name OptionsThirdShopOrder9
     * @summary updateSynLogisticsNo
     * @request OPTIONS:/thirdShopOrder/updateSynLogisticsNo
     * @originalName optionsThirdShopOrder
     * @duplicate
     */
    optionsThirdShopOrder9: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "OPTIONS",
        query: query,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags third-shop-order-controller
     * @name UpdateSynLogisticsNo5
     * @summary updateSynLogisticsNo
     * @request PATCH:/thirdShopOrder/updateSynLogisticsNo
     * @originalName updateSynLogisticsNo
     * @duplicate
     */
    updateSynLogisticsNo5: (
      query: {
        /**
         * shopOrderId
         * @format int64
         */
        shopOrderId: number;
        /**
         * status
         * @format int32
         */
        status: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<BizResponseBoolean, any>({
        path: `/thirdShopOrder/updateSynLogisticsNo`,
        method: "PATCH",
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  tiktok = {
    /**
     * No description
     *
     * @tags tiktok-shop-app-controller
     * @name Auth
     * @summary authTiktok
     * @request POST:/tiktok/auth
     */
    auth: (request: TiktokAuthRequest, params: RequestParams = {}) =>
      this.request<BizResponseLong, any>({
        path: `/tiktok/auth`,
        method: "POST",
        body: request,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags tiktok-shop-app-controller
     * @name Webhook
     * @summary webhook
     * @request POST:/tiktok/webhook
     */
    webhook: (webhookRequest: TiktokShopWebhookRequestDTO, params: RequestParams = {}) =>
      this.request<BizResponseVoid, any>({
        path: `/tiktok/webhook`,
        method: "POST",
        body: webhookRequest,
        type: ContentType.Json,
        ...params,
      }),
  };
  webhook = {
    /**
     * No description
     *
     * @tags cafe-24-webhook-controller
     * @name Cafe24DelApp
     * @summary delApp
     * @request POST:/webhook/cafe24/delApp
     */
    cafe24DelApp: (delAppWebhookDTO: DelAppWebhookDTO, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/webhook/cafe24/delApp`,
        method: "POST",
        body: delAppWebhookDTO,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺信息，客户信息
     * @name CustomerList
     * @summary customerData
     * @request POST:/webhook/customer/list
     */
    customerList: (params: RequestParams = {}) =>
      this.request<ThirdShopAuth[], any>({
        path: `/webhook/customer/list`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺信息，客户信息
     * @name DeleteCustomer
     * @summary deleteCustomer
     * @request POST:/webhook/delete/customer
     */
    deleteCustomer: (params: RequestParams = {}) =>
      this.request<ResponseEntity, any>({
        path: `/webhook/delete/customer`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags 店铺信息，客户信息
     * @name DeleteShop
     * @summary deleteShop
     * @request POST:/webhook/delete/shop
     */
    deleteShop: (params: RequestParams = {}) =>
      this.request<ResponseEntity, any>({
        path: `/webhook/delete/shop`,
        method: "POST",
        type: ContentType.Json,
        ...params,
      }),
  };
}
